/**
 * @generated SignedSource<<cc6e32e7d5f4dcbfc6c71d7b350e9fac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChargeSortField = "AMOUNT" | "AMOUNT_REFUNDED" | "CHARGE_TOTAL" | "CREATED" | "DATA" | "DESCRIPTION" | "HOLD_AMOUNT" | "ID" | "ORGANIZATION_ID" | "PARTNER_CHARGE" | "PARTNER_OLD_ID" | "PAYMENT_INTENT_ID" | "REFUNDED" | "REFUND_STATUS" | "STATUS" | "SYSTEM_ID" | "SYSTEM_OLD_ID" | "TAX_AMOUNT" | "TAX_RATE" | "USER_ID" | "USER_OLD_ID" | "WALLET_ID" | "%future added value";
export type HardwareState = "ACTIVE" | "INACTIVE" | "LOST" | "MAINTENANCE" | "MISSING" | "REBALANCE" | "RESERVED" | "RETIRED" | "STORED" | "UNASSIGNED" | "%future added value";
export type SortOrder = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type ChargeFilterInput = {
  amount?: ChargeFilterAmount | null | undefined;
  amountRefunded?: ChargeFilterAmountRefunded | null | undefined;
  and?: ReadonlyArray<ChargeFilterInput> | null | undefined;
  chargeTotal?: ChargeFilterChargeTotal | null | undefined;
  created?: ChargeFilterCreated | null | undefined;
  data?: ChargeFilterData | null | undefined;
  description?: ChargeFilterDescription | null | undefined;
  holdAmount?: ChargeFilterHoldAmount | null | undefined;
  id?: ChargeFilterId | null | undefined;
  not?: ReadonlyArray<ChargeFilterInput> | null | undefined;
  or?: ReadonlyArray<ChargeFilterInput> | null | undefined;
  organizationId?: ChargeFilterOrganizationId | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerCharge?: ChargeFilterPartnerCharge | null | undefined;
  partnerOldId?: ChargeFilterPartnerOldId | null | undefined;
  paymentIntentId?: ChargeFilterPaymentIntentId | null | undefined;
  refundStatus?: ChargeFilterRefundStatus | null | undefined;
  refunded?: ChargeFilterRefunded | null | undefined;
  refunds?: RefundFilterInput | null | undefined;
  rental?: RentalFilterInput | null | undefined;
  status?: ChargeFilterStatus | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: ChargeFilterSystemId | null | undefined;
  systemOldId?: ChargeFilterSystemOldId | null | undefined;
  taxAmount?: ChargeFilterTaxAmount | null | undefined;
  taxRate?: ChargeFilterTaxRate | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: ChargeFilterUserId | null | undefined;
  userOldId?: ChargeFilterUserOldId | null | undefined;
  wallet?: UserWalletFilterInput | null | undefined;
  walletId?: ChargeFilterWalletId | null | undefined;
  walletTransaction?: WalletTransactionFilterInput | null | undefined;
};
export type ChargeFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type ChargeFilterAmountRefunded = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type ChargeFilterChargeTotal = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ChargeFilterCreated = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ChargeFilterData = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ChargeFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ChargeFilterHoldAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type ChargeFilterId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ChargeFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PartnerFilterInput = {
  and?: ReadonlyArray<PartnerFilterInput> | null | undefined;
  id?: PartnerFilterId | null | undefined;
  not?: ReadonlyArray<PartnerFilterInput> | null | undefined;
  oldId?: PartnerFilterOldId | null | undefined;
  or?: ReadonlyArray<PartnerFilterInput> | null | undefined;
};
export type PartnerFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PartnerFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeFilterPartnerCharge = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type ChargeFilterPartnerOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeFilterPaymentIntentId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ChargeFilterRefundStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ChargeFilterRefunded = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RefundFilterInput = {
  amount?: RefundFilterAmount | null | undefined;
  and?: ReadonlyArray<RefundFilterInput> | null | undefined;
  charge?: ChargeFilterInput | null | undefined;
  chargeId?: RefundFilterChargeId | null | undefined;
  createdOn?: RefundFilterCreatedOn | null | undefined;
  description?: RefundFilterDescription | null | undefined;
  id?: RefundFilterId | null | undefined;
  not?: ReadonlyArray<RefundFilterInput> | null | undefined;
  or?: ReadonlyArray<RefundFilterInput> | null | undefined;
  organizationId?: RefundFilterOrganizationId | null | undefined;
  status?: RefundFilterStatus | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: RefundFilterSystemId | null | undefined;
  user?: UserFilterInput | null | undefined;
};
export type RefundFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RefundFilterChargeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RefundFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RefundFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RefundFilterId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RefundFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RefundFilterStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterInput = {
  activeHardwareCount?: SystemFilterActiveHardwareCount | null | undefined;
  activeRentalsCount?: SystemFilterActiveRentalsCount | null | undefined;
  adminSystemPermissions?: AdminSystemPermissionFilterInput | null | undefined;
  adminSystemRoles?: AdminSystemRoleFilterInput | null | undefined;
  adminSystems?: AdminSystemsFilterInput | null | undefined;
  allowRentalWithoutCard?: SystemFilterAllowRentalWithoutCard | null | undefined;
  and?: ReadonlyArray<SystemFilterInput> | null | undefined;
  availableHardwareCount?: SystemFilterAvailableHardwareCount | null | undefined;
  bannerOldId?: SystemFilterBannerOldId | null | undefined;
  billing?: SystemFilterBilling | null | undefined;
  billingLive?: SystemFilterBillingLive | null | undefined;
  charges?: ChargeFilterInput | null | undefined;
  closeTime?: SystemFilterCloseTime | null | undefined;
  closeTimeInt?: SystemFilterCloseTimeInt | null | undefined;
  closedReason?: SystemFilterClosedReason | null | undefined;
  colorPrimary?: SystemFilterColorPrimary | null | undefined;
  colorSecondary?: SystemFilterColorSecondary | null | undefined;
  config?: SystemFilterConfig | null | undefined;
  countryCode?: SystemFilterCountryCode | null | undefined;
  coupons?: CouponFilterInput | null | undefined;
  createdOn?: SystemFilterCreatedOn | null | undefined;
  creditCardHold?: SystemFilterCreditCardHold | null | undefined;
  currencyCode?: SystemFilterCurrencyCode | null | undefined;
  customCharges?: CustomChargeFilterInput | null | undefined;
  description?: SystemFilterDescription | null | undefined;
  disputes?: DisputeFilterInput | null | undefined;
  eventBatteryStatuses?: EventBatteryStatusFilterInput | null | undefined;
  eventErrors?: EventErrorFilterInput | null | undefined;
  eventLocations?: EventLocationFilterInput | null | undefined;
  eventStates?: EventStateFilterInput | null | undefined;
  events?: EventFilterInput | null | undefined;
  fees?: FeeFilterInput | null | undefined;
  forceEndPossible?: SystemFilterForceEndPossible | null | undefined;
  gracePeriod?: SystemFilterGracePeriod | null | undefined;
  groups?: GroupSystemFilterInput | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareProductConfigurations?: HardwareProductConfigurationFilterInput | null | undefined;
  hasRates?: SystemFilterHasRates | null | undefined;
  id?: SystemFilterId | null | undefined;
  invoices?: InvoiceFilterInput | null | undefined;
  isDemoSystem?: SystemFilterIsDemoSystem | null | undefined;
  isPrivateSystem?: SystemFilterIsPrivateSystem | null | undefined;
  isVisible?: SystemFilterIsVisible | null | undefined;
  issuingCards?: IssuingCardFilterInput | null | undefined;
  lat?: SystemFilterLat | null | undefined;
  lng?: SystemFilterLng | null | undefined;
  locations?: LocationFilterInput | null | undefined;
  logoOldId?: SystemFilterLogoOldId | null | undefined;
  maintenanceLogs?: MaintenanceLogFilterInput | null | undefined;
  maintenanceRecurringRules?: MaintenanceRecurringRuleFilterInput | null | undefined;
  maintenanceTasks?: MaintenanceTaskFilterInput | null | undefined;
  maintenanceTicketTags?: MaintenanceTicketTagFilterInput | null | undefined;
  maintenanceTickets?: MaintenanceTicketFilterInput | null | undefined;
  manualCharges?: ManualChargeFilterInput | null | undefined;
  maxChargeThreshold?: SystemFilterMaxChargeThreshold | null | undefined;
  maxOpenRentals?: SystemFilterMaxOpenRentals | null | undefined;
  maxSpeed?: SystemFilterMaxSpeed | null | undefined;
  memberships?: MembershipFilterInput | null | undefined;
  minimumWalletDeposit?: SystemFilterMinimumWalletDeposit | null | undefined;
  mobilityType?: SystemFilterMobilityType | null | undefined;
  name?: SystemFilterName | null | undefined;
  newHardware?: SystemFilterNewHardware | null | undefined;
  not?: ReadonlyArray<SystemFilterInput> | null | undefined;
  notifications?: NotificationFilterInput | null | undefined;
  oldId?: SystemFilterOldId | null | undefined;
  openDisputesCount?: SystemFilterOpenDisputesCount | null | undefined;
  openTime?: SystemFilterOpenTime | null | undefined;
  openTimeInt?: SystemFilterOpenTimeInt | null | undefined;
  operatingHours?: SystemFilterOperatingHours | null | undefined;
  or?: ReadonlyArray<SystemFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: SystemFilterOrganizationId | null | undefined;
  outsideSystemMaxSpeed?: SystemFilterOutsideSystemMaxSpeed | null | undefined;
  overdueMaintenanceTicketCount?: SystemFilterOverdueMaintenanceTicketCount | null | undefined;
  ownerEmail?: SystemFilterOwnerEmail | null | undefined;
  parkingCreditOutsideDesignated?: SystemFilterParkingCreditOutsideDesignated | null | undefined;
  parkingCreditOutsideSystemServiceZone?: SystemFilterParkingCreditOutsideSystemServiceZone | null | undefined;
  parkingCreditParkingZone?: SystemFilterParkingCreditParkingZone | null | undefined;
  parkingCreditPreferredParkingZone?: SystemFilterParkingCreditPreferredParkingZone | null | undefined;
  parkingCreditRackStation?: SystemFilterParkingCreditRackStation | null | undefined;
  parkingCreditRestrictedZone?: SystemFilterParkingCreditRestrictedZone | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerId?: SystemFilterPartnerId | null | undefined;
  pendingChargesCount?: SystemFilterPendingChargesCount | null | undefined;
  perks?: PerkFilterInput | null | undefined;
  providerId?: SystemFilterProviderId | null | undefined;
  providerName?: SystemFilterProviderName | null | undefined;
  qrCodeReservations?: QrCodeReservationFilterInput | null | undefined;
  rateConfigurations?: RateConfigurationFilterInput | null | undefined;
  rates?: RateFilterInput | null | undefined;
  refunds?: RefundFilterInput | null | undefined;
  rentableHardwareCount?: SystemFilterRentableHardwareCount | null | undefined;
  rentableHardwareType?: HardwareTypeFilterInput | null | undefined;
  rentableHardwareTypeId?: SystemFilterRentableHardwareTypeId | null | undefined;
  rentalLengthWarning?: SystemFilterRentalLengthWarning | null | undefined;
  rentalRoutes?: RentalRouteFilterInput | null | undefined;
  rentalTutorials?: RentalTutorialFilterInput | null | undefined;
  rentals?: RentalFilterInput | null | undefined;
  rentalsCount?: SystemFilterRentalsCount | null | undefined;
  requireCreditCard?: SystemFilterRequireCreditCard | null | undefined;
  roundTrip?: SystemFilterRoundTrip | null | undefined;
  status?: SystemFilterStatus | null | undefined;
  stripeAccount?: SystemFilterStripeAccount | null | undefined;
  supportPhoneNumber?: SystemFilterSupportPhoneNumber | null | undefined;
  supportTicketTags?: SupportTicketTagFilterInput | null | undefined;
  supportTickets?: SupportTicketFilterInput | null | undefined;
  supportTicketsCount?: SystemFilterSupportTicketsCount | null | undefined;
  supportsInRentalUnlock?: SystemFilterSupportsInRentalUnlock | null | undefined;
  systemConfigurations?: SystemConfigurationFilterInput | null | undefined;
  taxRate?: SystemFilterTaxRate | null | undefined;
  testStripeAccount?: SystemFilterTestStripeAccount | null | undefined;
  timezone?: SystemFilterTimezone | null | undefined;
  timezoneOffset?: SystemFilterTimezoneOffset | null | undefined;
  tos?: SystemFilterTos | null | undefined;
  transfers?: TransferFilterInput | null | undefined;
  userSystems?: UserSystemFilterInput | null | undefined;
  usersCount?: SystemFilterUsersCount | null | undefined;
  walletTransactions?: WalletTransactionFilterInput | null | undefined;
};
export type SystemFilterActiveHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterActiveRentalsCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type AdminSystemPermissionFilterInput = {
  admin?: AdminUserFilterInput | null | undefined;
  adminId?: AdminSystemPermissionFilterAdminId | null | undefined;
  and?: ReadonlyArray<AdminSystemPermissionFilterInput> | null | undefined;
  createdOn?: AdminSystemPermissionFilterCreatedOn | null | undefined;
  not?: ReadonlyArray<AdminSystemPermissionFilterInput> | null | undefined;
  or?: ReadonlyArray<AdminSystemPermissionFilterInput> | null | undefined;
  organizationId?: AdminSystemPermissionFilterOrganizationId | null | undefined;
  permission?: PermissionFilterInput | null | undefined;
  permissionId?: AdminSystemPermissionFilterPermissionId | null | undefined;
  removedOn?: AdminSystemPermissionFilterRemovedOn | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: AdminSystemPermissionFilterSystemId | null | undefined;
  updatedOn?: AdminSystemPermissionFilterUpdatedOn | null | undefined;
};
export type AdminUserFilterInput = {
  adminOrganizationPermissions?: AdminOrganizationPermissionFilterInput | null | undefined;
  adminOrganizationRoles?: AdminOrganizationRoleFilterInput | null | undefined;
  adminSystemPermissions?: AdminSystemPermissionFilterInput | null | undefined;
  adminSystemRoles?: AdminSystemRoleFilterInput | null | undefined;
  adminSystems?: AdminSystemsFilterInput | null | undefined;
  and?: ReadonlyArray<AdminUserFilterInput> | null | undefined;
  communicationLogs?: CommunicationLogFilterInput | null | undefined;
  email?: AdminUserFilterEmail | null | undefined;
  firstName?: AdminUserFilterFirstName | null | undefined;
  id?: AdminUserFilterId | null | undefined;
  isMovaticAdmin?: AdminUserFilterIsMovaticAdmin | null | undefined;
  lastName?: AdminUserFilterLastName | null | undefined;
  not?: ReadonlyArray<AdminUserFilterInput> | null | undefined;
  or?: ReadonlyArray<AdminUserFilterInput> | null | undefined;
};
export type AdminOrganizationPermissionFilterInput = {
  admin?: AdminUserFilterInput | null | undefined;
  adminId?: AdminOrganizationPermissionFilterAdminId | null | undefined;
  and?: ReadonlyArray<AdminOrganizationPermissionFilterInput> | null | undefined;
  createdOn?: AdminOrganizationPermissionFilterCreatedOn | null | undefined;
  not?: ReadonlyArray<AdminOrganizationPermissionFilterInput> | null | undefined;
  or?: ReadonlyArray<AdminOrganizationPermissionFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: AdminOrganizationPermissionFilterOrganizationId | null | undefined;
  permission?: PermissionFilterInput | null | undefined;
  permissionId?: AdminOrganizationPermissionFilterPermissionId | null | undefined;
  removedOn?: AdminOrganizationPermissionFilterRemovedOn | null | undefined;
  updatedOn?: AdminOrganizationPermissionFilterUpdatedOn | null | undefined;
};
export type AdminOrganizationPermissionFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminOrganizationPermissionFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterInput = {
  activeHardwareCount?: OrganizationFilterActiveHardwareCount | null | undefined;
  activeRentalsCount?: OrganizationFilterActiveRentalsCount | null | undefined;
  and?: ReadonlyArray<OrganizationFilterInput> | null | undefined;
  applicationOrganizations?: ApplicationOrganizationFilterInput | null | undefined;
  availableHardwareCount?: OrganizationFilterAvailableHardwareCount | null | undefined;
  childHierarchies?: OrganizationHierarchyFilterInput | null | undefined;
  children?: OrganizationFilterInput | null | undefined;
  config?: OrganizationFilterConfig | null | undefined;
  createdBy?: OrganizationFilterCreatedBy | null | undefined;
  createdOn?: OrganizationFilterCreatedOn | null | undefined;
  descendants?: OrganizationFilterInput | null | undefined;
  hasBrandedApp?: OrganizationFilterHasBrandedApp | null | undefined;
  id?: OrganizationFilterId | null | undefined;
  name?: OrganizationFilterName | null | undefined;
  not?: ReadonlyArray<OrganizationFilterInput> | null | undefined;
  openDisputesCount?: OrganizationFilterOpenDisputesCount | null | undefined;
  or?: ReadonlyArray<OrganizationFilterInput> | null | undefined;
  organizationAdmins?: OrganizationAdminFilterInput | null | undefined;
  organizationSystems?: OrganizationSystemFilterInput | null | undefined;
  overdueMaintenanceTicketCount?: OrganizationFilterOverdueMaintenanceTicketCount | null | undefined;
  parent?: OrganizationFilterInput | null | undefined;
  parentHierarchy?: OrganizationHierarchyFilterInput | null | undefined;
  pendingChargesCount?: OrganizationFilterPendingChargesCount | null | undefined;
  removedOn?: OrganizationFilterRemovedOn | null | undefined;
  rentableHardwareCount?: OrganizationFilterRentableHardwareCount | null | undefined;
  rentalsCount?: OrganizationFilterRentalsCount | null | undefined;
  supportTicketsCount?: OrganizationFilterSupportTicketsCount | null | undefined;
  updatedOn?: OrganizationFilterUpdatedOn | null | undefined;
  usersCount?: OrganizationFilterUsersCount | null | undefined;
};
export type OrganizationFilterActiveHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationFilterActiveRentalsCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type ApplicationOrganizationFilterInput = {
  and?: ReadonlyArray<ApplicationOrganizationFilterInput> | null | undefined;
  application?: ApplicationFilterInput | null | undefined;
  applicationId?: ApplicationOrganizationFilterApplicationId | null | undefined;
  config?: ApplicationOrganizationFilterConfig | null | undefined;
  createdOn?: ApplicationOrganizationFilterCreatedOn | null | undefined;
  id?: ApplicationOrganizationFilterId | null | undefined;
  not?: ReadonlyArray<ApplicationOrganizationFilterInput> | null | undefined;
  or?: ReadonlyArray<ApplicationOrganizationFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: ApplicationOrganizationFilterOrganizationId | null | undefined;
  removedOn?: ApplicationOrganizationFilterRemovedOn | null | undefined;
  updatedOn?: ApplicationOrganizationFilterUpdatedOn | null | undefined;
};
export type ApplicationFilterInput = {
  and?: ReadonlyArray<ApplicationFilterInput> | null | undefined;
  id?: ApplicationFilterId | null | undefined;
  not?: ReadonlyArray<ApplicationFilterInput> | null | undefined;
  or?: ReadonlyArray<ApplicationFilterInput> | null | undefined;
};
export type ApplicationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ApplicationOrganizationFilterApplicationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ApplicationOrganizationFilterConfig = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ApplicationOrganizationFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ApplicationOrganizationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ApplicationOrganizationFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ApplicationOrganizationFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ApplicationOrganizationFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterAvailableHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationHierarchyFilterInput = {
  and?: ReadonlyArray<OrganizationHierarchyFilterInput> | null | undefined;
  childOrganization?: OrganizationFilterInput | null | undefined;
  childOrganizationId?: OrganizationHierarchyFilterChildOrganizationId | null | undefined;
  config?: OrganizationHierarchyFilterConfig | null | undefined;
  createdOn?: OrganizationHierarchyFilterCreatedOn | null | undefined;
  id?: OrganizationHierarchyFilterId | null | undefined;
  not?: ReadonlyArray<OrganizationHierarchyFilterInput> | null | undefined;
  or?: ReadonlyArray<OrganizationHierarchyFilterInput> | null | undefined;
  parentOrganization?: OrganizationFilterInput | null | undefined;
  parentOrganizationId?: OrganizationHierarchyFilterParentOrganizationId | null | undefined;
  removedOn?: OrganizationHierarchyFilterRemovedOn | null | undefined;
  updatedOn?: OrganizationHierarchyFilterUpdatedOn | null | undefined;
};
export type OrganizationHierarchyFilterChildOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationHierarchyFilterConfig = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationHierarchyFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationHierarchyFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationHierarchyFilterParentOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationHierarchyFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationHierarchyFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterConfig = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterCreatedBy = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterHasBrandedApp = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type OrganizationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type OrganizationFilterOpenDisputesCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationAdminFilterInput = {
  admin?: AdminUserFilterInput | null | undefined;
  adminId?: OrganizationAdminFilterAdminId | null | undefined;
  and?: ReadonlyArray<OrganizationAdminFilterInput> | null | undefined;
  config?: OrganizationAdminFilterConfig | null | undefined;
  createdOn?: OrganizationAdminFilterCreatedOn | null | undefined;
  id?: OrganizationAdminFilterId | null | undefined;
  not?: ReadonlyArray<OrganizationAdminFilterInput> | null | undefined;
  or?: ReadonlyArray<OrganizationAdminFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: OrganizationAdminFilterOrganizationId | null | undefined;
  removedOn?: OrganizationAdminFilterRemovedOn | null | undefined;
  updatedOn?: OrganizationAdminFilterUpdatedOn | null | undefined;
};
export type OrganizationAdminFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationAdminFilterConfig = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationAdminFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationAdminFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationAdminFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationAdminFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationAdminFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationSystemFilterInput = {
  and?: ReadonlyArray<OrganizationSystemFilterInput> | null | undefined;
  config?: OrganizationSystemFilterConfig | null | undefined;
  createdOn?: OrganizationSystemFilterCreatedOn | null | undefined;
  id?: OrganizationSystemFilterId | null | undefined;
  not?: ReadonlyArray<OrganizationSystemFilterInput> | null | undefined;
  or?: ReadonlyArray<OrganizationSystemFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: OrganizationSystemFilterOrganizationId | null | undefined;
  removedOn?: OrganizationSystemFilterRemovedOn | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: OrganizationSystemFilterSystemId | null | undefined;
  updatedOn?: OrganizationSystemFilterUpdatedOn | null | undefined;
};
export type OrganizationSystemFilterConfig = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationSystemFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationSystemFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationSystemFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationSystemFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationSystemFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type OrganizationSystemFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterOverdueMaintenanceTicketCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationFilterPendingChargesCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterRentableHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationFilterRentalsCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationFilterSupportTicketsCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type OrganizationFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type OrganizationFilterUsersCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type AdminOrganizationPermissionFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PermissionFilterInput = {
  adminOrganizationPermissions?: AdminOrganizationPermissionFilterInput | null | undefined;
  adminSystemPermissions?: AdminSystemPermissionFilterInput | null | undefined;
  and?: ReadonlyArray<PermissionFilterInput> | null | undefined;
  application?: ApplicationFilterInput | null | undefined;
  applicationId?: PermissionFilterApplicationId | null | undefined;
  createdOn?: PermissionFilterCreatedOn | null | undefined;
  id?: PermissionFilterId | null | undefined;
  name?: PermissionFilterName | null | undefined;
  not?: ReadonlyArray<PermissionFilterInput> | null | undefined;
  or?: ReadonlyArray<PermissionFilterInput> | null | undefined;
  removedOn?: PermissionFilterRemovedOn | null | undefined;
  rolePermissions?: RolePermissionFilterInput | null | undefined;
  roles?: RoleFilterInput | null | undefined;
  updatedOn?: PermissionFilterUpdatedOn | null | undefined;
};
export type PermissionFilterApplicationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PermissionFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type PermissionFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PermissionFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type PermissionFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RolePermissionFilterInput = {
  and?: ReadonlyArray<RolePermissionFilterInput> | null | undefined;
  createdOn?: RolePermissionFilterCreatedOn | null | undefined;
  not?: ReadonlyArray<RolePermissionFilterInput> | null | undefined;
  or?: ReadonlyArray<RolePermissionFilterInput> | null | undefined;
  permission?: PermissionFilterInput | null | undefined;
  permissionId?: RolePermissionFilterPermissionId | null | undefined;
  removedOn?: RolePermissionFilterRemovedOn | null | undefined;
  role?: RoleFilterInput | null | undefined;
  roleId?: RolePermissionFilterRoleId | null | undefined;
  updatedOn?: RolePermissionFilterUpdatedOn | null | undefined;
};
export type RolePermissionFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RolePermissionFilterPermissionId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RolePermissionFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RoleFilterInput = {
  adminOrganizationRoles?: AdminOrganizationRoleFilterInput | null | undefined;
  adminSystemRoles?: AdminSystemRoleFilterInput | null | undefined;
  allPermissions?: PermissionFilterInput | null | undefined;
  and?: ReadonlyArray<RoleFilterInput> | null | undefined;
  application?: ApplicationFilterInput | null | undefined;
  applicationId?: RoleFilterApplicationId | null | undefined;
  childHierarchies?: RoleHierarchyFilterInput | null | undefined;
  childRoles?: RoleFilterInput | null | undefined;
  createdOn?: RoleFilterCreatedOn | null | undefined;
  id?: RoleFilterId | null | undefined;
  inheritedRoles?: RoleFilterInput | null | undefined;
  name?: RoleFilterName | null | undefined;
  not?: ReadonlyArray<RoleFilterInput> | null | undefined;
  or?: ReadonlyArray<RoleFilterInput> | null | undefined;
  parentHierarchies?: RoleHierarchyFilterInput | null | undefined;
  parentRoles?: RoleFilterInput | null | undefined;
  permissions?: PermissionFilterInput | null | undefined;
  removedOn?: RoleFilterRemovedOn | null | undefined;
  rolePermissions?: RolePermissionFilterInput | null | undefined;
  updatedOn?: RoleFilterUpdatedOn | null | undefined;
};
export type AdminOrganizationRoleFilterInput = {
  admin?: AdminUserFilterInput | null | undefined;
  adminId?: AdminOrganizationRoleFilterAdminId | null | undefined;
  and?: ReadonlyArray<AdminOrganizationRoleFilterInput> | null | undefined;
  createdOn?: AdminOrganizationRoleFilterCreatedOn | null | undefined;
  not?: ReadonlyArray<AdminOrganizationRoleFilterInput> | null | undefined;
  or?: ReadonlyArray<AdminOrganizationRoleFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: AdminOrganizationRoleFilterOrganizationId | null | undefined;
  removedOn?: AdminOrganizationRoleFilterRemovedOn | null | undefined;
  role?: RoleFilterInput | null | undefined;
  roleId?: AdminOrganizationRoleFilterRoleId | null | undefined;
  updatedOn?: AdminOrganizationRoleFilterUpdatedOn | null | undefined;
};
export type AdminOrganizationRoleFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminOrganizationRoleFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminOrganizationRoleFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminOrganizationRoleFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminOrganizationRoleFilterRoleId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminOrganizationRoleFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminSystemRoleFilterInput = {
  admin?: AdminUserFilterInput | null | undefined;
  adminId?: AdminSystemRoleFilterAdminId | null | undefined;
  and?: ReadonlyArray<AdminSystemRoleFilterInput> | null | undefined;
  createdOn?: AdminSystemRoleFilterCreatedOn | null | undefined;
  not?: ReadonlyArray<AdminSystemRoleFilterInput> | null | undefined;
  or?: ReadonlyArray<AdminSystemRoleFilterInput> | null | undefined;
  organizationId?: AdminSystemRoleFilterOrganizationId | null | undefined;
  removedOn?: AdminSystemRoleFilterRemovedOn | null | undefined;
  role?: RoleFilterInput | null | undefined;
  roleId?: AdminSystemRoleFilterRoleId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: AdminSystemRoleFilterSystemId | null | undefined;
  updatedOn?: AdminSystemRoleFilterUpdatedOn | null | undefined;
};
export type AdminSystemRoleFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemRoleFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminSystemRoleFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemRoleFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminSystemRoleFilterRoleId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemRoleFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemRoleFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RoleFilterApplicationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RoleHierarchyFilterInput = {
  and?: ReadonlyArray<RoleHierarchyFilterInput> | null | undefined;
  child?: RoleFilterInput | null | undefined;
  childId?: RoleHierarchyFilterChildId | null | undefined;
  createdOn?: RoleHierarchyFilterCreatedOn | null | undefined;
  not?: ReadonlyArray<RoleHierarchyFilterInput> | null | undefined;
  or?: ReadonlyArray<RoleHierarchyFilterInput> | null | undefined;
  parent?: RoleFilterInput | null | undefined;
  parentId?: RoleHierarchyFilterParentId | null | undefined;
  removedOn?: RoleHierarchyFilterRemovedOn | null | undefined;
  updatedOn?: RoleHierarchyFilterUpdatedOn | null | undefined;
};
export type RoleHierarchyFilterChildId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RoleHierarchyFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RoleHierarchyFilterParentId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RoleHierarchyFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RoleHierarchyFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RoleFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RoleFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RoleFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RoleFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RoleFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RolePermissionFilterRoleId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RolePermissionFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type PermissionFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminOrganizationPermissionFilterPermissionId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminOrganizationPermissionFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminOrganizationPermissionFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminSystemsFilterInput = {
  adminUser?: AdminUserFilterInput | null | undefined;
  and?: ReadonlyArray<AdminSystemsFilterInput> | null | undefined;
  not?: ReadonlyArray<AdminSystemsFilterInput> | null | undefined;
  or?: ReadonlyArray<AdminSystemsFilterInput> | null | undefined;
  organizationId?: AdminSystemsFilterOrganizationId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: AdminSystemsFilterSystemId | null | undefined;
};
export type AdminSystemsFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemsFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CommunicationLogFilterInput = {
  adminId?: CommunicationLogFilterAdminId | null | undefined;
  adminUser?: AdminUserFilterInput | null | undefined;
  and?: ReadonlyArray<CommunicationLogFilterInput> | null | undefined;
  countryCode?: CommunicationLogFilterCountryCode | null | undefined;
  createdOn?: CommunicationLogFilterCreatedOn | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareId?: CommunicationLogFilterHardwareId | null | undefined;
  id?: CommunicationLogFilterId | null | undefined;
  ipAddress?: CommunicationLogFilterIpAddress | null | undefined;
  logPurpose?: CommunicationLogFilterLogPurpose | null | undefined;
  logType?: CommunicationLogFilterLogType | null | undefined;
  not?: ReadonlyArray<CommunicationLogFilterInput> | null | undefined;
  or?: ReadonlyArray<CommunicationLogFilterInput> | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: CommunicationLogFilterUserId | null | undefined;
};
export type CommunicationLogFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CommunicationLogFilterCountryCode = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CommunicationLogFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareFilterInput = {
  activeRental?: RentalFilterInput | null | undefined;
  activeRentalId?: HardwareFilterActiveRentalId | null | undefined;
  and?: ReadonlyArray<HardwareFilterInput> | null | undefined;
  batteryPercent?: HardwareFilterBatteryPercent | null | undefined;
  batteryVoltage?: HardwareFilterBatteryVoltage | null | undefined;
  charging?: HardwareFilterCharging | null | undefined;
  childHardwareAssignments?: HardwareAssignmentFilterInput | null | undefined;
  children?: HardwareFilterInput | null | undefined;
  communicationLogs?: CommunicationLogFilterInput | null | undefined;
  createdOn?: HardwareFilterCreatedOn | null | undefined;
  events?: EventFilterInput | null | undefined;
  firmwareVersion?: HardwareFilterFirmwareVersion | null | undefined;
  hardwareProduct?: HardwareProductFilterInput | null | undefined;
  hardwareProductId?: HardwareFilterHardwareProductId | null | undefined;
  hardwareProductOldId?: HardwareFilterHardwareProductOldId | null | undefined;
  hardwareProductVersion?: HardwareProductVersionFilterInput | null | undefined;
  hardwareProductVersionId?: HardwareFilterHardwareProductVersionId | null | undefined;
  hardwareProductVersionOldId?: HardwareFilterHardwareProductVersionOldId | null | undefined;
  hardwareType?: HardwareTypeFilterInput | null | undefined;
  hasLatestFirmwareVersion?: HardwareFilterHasLatestFirmwareVersion | null | undefined;
  hasLowBattery?: HardwareFilterHasLowBattery | null | undefined;
  hasOfflineUnlockableChild?: HardwareFilterHasOfflineUnlockableChild | null | undefined;
  iccid?: HardwareFilterIccid | null | undefined;
  id?: HardwareFilterId | null | undefined;
  imei?: HardwareFilterImei | null | undefined;
  isActive?: HardwareFilterIsActive | null | undefined;
  isAvailable?: HardwareFilterIsAvailable | null | undefined;
  isConnected?: HardwareFilterIsConnected | null | undefined;
  isInRental?: HardwareFilterIsInRental | null | undefined;
  isOccupied?: HardwareFilterIsOccupied | null | undefined;
  isOnline?: HardwareFilterIsOnline | null | undefined;
  isRentable?: HardwareFilterIsRentable | null | undefined;
  isUnlocked?: HardwareFilterIsUnlocked | null | undefined;
  label?: HardwareFilterLabel | null | undefined;
  lastSeen?: HardwareFilterLastSeen | null | undefined;
  lat?: HardwareFilterLat | null | undefined;
  lng?: HardwareFilterLng | null | undefined;
  location?: LocationFilterInput | null | undefined;
  locationId?: HardwareFilterLocationId | null | undefined;
  locationOldId?: HardwareFilterLocationOldId | null | undefined;
  mac?: HardwareFilterMac | null | undefined;
  maintenanceLogs?: MaintenanceLogFilterInput | null | undefined;
  maintenanceTickets?: MaintenanceTicketFilterInput | null | undefined;
  not?: ReadonlyArray<HardwareFilterInput> | null | undefined;
  number?: HardwareFilterNumber | null | undefined;
  numberText?: HardwareFilterNumberText | null | undefined;
  oldId?: HardwareFilterOldId | null | undefined;
  openMaintenanceTickets?: HardwareFilterOpenMaintenanceTickets | null | undefined;
  or?: ReadonlyArray<HardwareFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: HardwareFilterOrganizationId | null | undefined;
  overdueMaintenanceTickets?: HardwareFilterOverdueMaintenanceTickets | null | undefined;
  parent?: HardwareFilterInput | null | undefined;
  parentHardwareAssignments?: HardwareAssignmentFilterInput | null | undefined;
  qrCode?: QrCodeFilterInput | null | undefined;
  rentalCount?: HardwareFilterRentalCount | null | undefined;
  rentals?: RentalFilterInput | null | undefined;
  rssi?: HardwareFilterRssi | null | undefined;
  state?: HardwareFilterState | null | undefined;
  stateName?: HardwareFilterStateName | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: HardwareFilterSystemId | null | undefined;
  systemOldId?: HardwareFilterSystemOldId | null | undefined;
  unlockLogs?: UnlockLogFilterInput | null | undefined;
  unlockSuccessRate?: HardwareFilterUnlockSuccessRate | null | undefined;
  uptime?: HardwareFilterUptime | null | undefined;
  vendorId?: HardwareFilterVendorId | null | undefined;
  vendorQrCode?: HardwareFilterVendorQrCode | null | undefined;
  vendorSerial?: HardwareFilterVendorSerial | null | undefined;
};
export type RentalFilterInput = {
  adminModification?: RentalFilterAdminModification | null | undefined;
  adminModificationReason?: RentalFilterAdminModificationReason | null | undefined;
  and?: ReadonlyArray<RentalFilterInput> | null | undefined;
  canceledOn?: RentalFilterCanceledOn | null | undefined;
  ccHold?: ChargeFilterInput | null | undefined;
  ccHoldId?: RentalFilterCcHoldId | null | undefined;
  charge?: ChargeFilterInput | null | undefined;
  chargeAmount?: RentalFilterChargeAmount | null | undefined;
  chargeId?: RentalFilterChargeId | null | undefined;
  chargePending?: RentalFilterChargePending | null | undefined;
  chargePendingDecisionDate?: RentalFilterChargePendingDecisionDate | null | undefined;
  chargePendingNote?: RentalFilterChargePendingNote | null | undefined;
  chargePendingStatus?: RentalFilterChargePendingStatus | null | undefined;
  chargeSuccess?: RentalFilterChargeSuccess | null | undefined;
  chargeTotal?: RentalFilterChargeTotal | null | undefined;
  completed?: RentalFilterCompleted | null | undefined;
  coupon?: CouponFilterInput | null | undefined;
  couponId?: RentalFilterCouponId | null | undefined;
  createdOn?: RentalFilterCreatedOn | null | undefined;
  data?: RentalFilterData | null | undefined;
  deviceId?: RentalFilterDeviceId | null | undefined;
  distance?: RentalFilterDistance | null | undefined;
  duration?: RentalFilterDuration | null | undefined;
  effectiveGracePeriod?: RentalFilterEffectiveGracePeriod | null | undefined;
  endAdminUserId?: RentalFilterEndAdminUserId | null | undefined;
  endBy?: RentalFilterEndBy | null | undefined;
  endDevice?: DeviceFilterInput | null | undefined;
  endDeviceId?: RentalFilterEndDeviceId | null | undefined;
  endImageUrl?: RentalFilterEndImageUrl | null | undefined;
  endLat?: RentalFilterEndLat | null | undefined;
  endLng?: RentalFilterEndLng | null | undefined;
  endLocation?: LocationFilterInput | null | undefined;
  endLocationOldId?: RentalFilterEndLocationOldId | null | undefined;
  endParentHardware?: HardwareFilterInput | null | undefined;
  endParentHardwareId?: RentalFilterEndParentHardwareId | null | undefined;
  endRack?: RentalFilterEndRack | null | undefined;
  endTime?: RentalFilterEndTime | null | undefined;
  endType?: RentalFilterEndType | null | undefined;
  endUserRfidCardId?: RentalFilterEndUserRfidCardId | null | undefined;
  endedWithinGracePeriod?: RentalFilterEndedWithinGracePeriod | null | undefined;
  failedStart?: RentalFilterFailedStart | null | undefined;
  feesPostTaxAmount?: RentalFilterFeesPostTaxAmount | null | undefined;
  forceEndAck?: RentalFilterForceEndAck | null | undefined;
  forceEndTime?: RentalFilterForceEndTime | null | undefined;
  forceEndType?: RentalFilterForceEndType | null | undefined;
  gracePeriod?: RentalFilterGracePeriod | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareOldId?: RentalFilterHardwareOldId | null | undefined;
  id?: RentalFilterId | null | undefined;
  isVoidCharge?: RentalFilterIsVoidCharge | null | undefined;
  membershipMinutesConsumed?: RentalFilterMembershipMinutesConsumed | null | undefined;
  not?: ReadonlyArray<RentalFilterInput> | null | undefined;
  oldId?: RentalFilterOldId | null | undefined;
  or?: ReadonlyArray<RentalFilterInput> | null | undefined;
  organizationId?: RentalFilterOrganizationId | null | undefined;
  parkingCredit?: RentalFilterParkingCredit | null | undefined;
  paymentMethodId?: RentalFilterPaymentMethodId | null | undefined;
  perk?: PerkFilterInput | null | undefined;
  perkOldId?: RentalFilterPerkOldId | null | undefined;
  rate?: RateFilterInput | null | undefined;
  rateOldId?: RentalFilterRateOldId | null | undefined;
  rating?: RentalFilterRating | null | undefined;
  refundAmount?: RentalFilterRefundAmount | null | undefined;
  refundComment?: RentalFilterRefundComment | null | undefined;
  reviewStatus?: RentalFilterReviewStatus | null | undefined;
  startAdminUserId?: RentalFilterStartAdminUserId | null | undefined;
  startDevice?: DeviceFilterInput | null | undefined;
  startDeviceId?: RentalFilterStartDeviceId | null | undefined;
  startLat?: RentalFilterStartLat | null | undefined;
  startLng?: RentalFilterStartLng | null | undefined;
  startLocation?: LocationFilterInput | null | undefined;
  startLocationOldId?: RentalFilterStartLocationOldId | null | undefined;
  startParentHardware?: HardwareFilterInput | null | undefined;
  startParentHardwareId?: RentalFilterStartParentHardwareId | null | undefined;
  startRack?: RentalFilterStartRack | null | undefined;
  startTime?: RentalFilterStartTime | null | undefined;
  startType?: RentalFilterStartType | null | undefined;
  startUserRfidCardId?: RentalFilterStartUserRfidCardId | null | undefined;
  supportMessages?: SupportTicketFilterInput | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: RentalFilterSystemId | null | undefined;
  systemOldId?: RentalFilterSystemOldId | null | undefined;
  taxAmount?: RentalFilterTaxAmount | null | undefined;
  taxRate?: RentalFilterTaxRate | null | undefined;
  tripDistance?: RentalFilterTripDistance | null | undefined;
  usageSubtotal?: RentalFilterUsageSubtotal | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: RentalFilterUserId | null | undefined;
  userOldId?: RentalFilterUserOldId | null | undefined;
  voidBy?: RentalFilterVoidBy | null | undefined;
  voidByAdmin?: AdminUserFilterInput | null | undefined;
  voidReason?: RentalFilterVoidReason | null | undefined;
  voidedOn?: RentalFilterVoidedOn | null | undefined;
  walletTransaction?: WalletTransactionFilterInput | null | undefined;
  walletTransactionOldId?: RentalFilterWalletTransactionOldId | null | undefined;
};
export type RentalFilterAdminModification = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterAdminModificationReason = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterCanceledOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterCcHoldId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterChargeAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterChargeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterChargePending = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RentalFilterChargePendingDecisionDate = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterChargePendingNote = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterChargePendingStatus = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RentalFilterChargeSuccess = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RentalFilterChargeTotal = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterCompleted = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type CouponFilterInput = {
  active?: CouponFilterActive | null | undefined;
  and?: ReadonlyArray<CouponFilterInput> | null | undefined;
  assignmentOnly?: CouponFilterAssignmentOnly | null | undefined;
  code?: CouponFilterCode | null | undefined;
  created?: CouponFilterCreated | null | undefined;
  discount?: CouponFilterDiscount | null | undefined;
  discountType?: CouponFilterDiscountType | null | undefined;
  duration?: CouponFilterDuration | null | undefined;
  effectiveOrganizationId?: CouponFilterEffectiveOrganizationId | null | undefined;
  id?: CouponFilterId | null | undefined;
  name?: CouponFilterName | null | undefined;
  not?: ReadonlyArray<CouponFilterInput> | null | undefined;
  oldId?: CouponFilterOldId | null | undefined;
  or?: ReadonlyArray<CouponFilterInput> | null | undefined;
  organization?: OrganizationFilterInput | null | undefined;
  organizationId?: CouponFilterOrganizationId | null | undefined;
  systemId?: CouponFilterSystemId | null | undefined;
  systemOldId?: CouponFilterSystemOldId | null | undefined;
  userCoupons?: UserCouponFilterInput | null | undefined;
  uses?: CouponFilterUses | null | undefined;
  validDays?: CouponFilterValidDays | null | undefined;
  validFrom?: CouponFilterValidFrom | null | undefined;
  validTimeEnd?: CouponFilterValidTimeEnd | null | undefined;
  validTimeStart?: CouponFilterValidTimeStart | null | undefined;
  validUntil?: CouponFilterValidUntil | null | undefined;
};
export type CouponFilterActive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type CouponFilterAssignmentOnly = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type CouponFilterCode = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CouponFilterCreated = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type CouponFilterDiscount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CouponFilterDiscountType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CouponFilterDuration = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CouponFilterEffectiveOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CouponFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CouponFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CouponFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CouponFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CouponFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CouponFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserCouponFilterInput = {
  and?: ReadonlyArray<UserCouponFilterInput> | null | undefined;
  assignedBy?: UserCouponFilterAssignedBy | null | undefined;
  coupon?: CouponFilterInput | null | undefined;
  couponOldId?: UserCouponFilterCouponOldId | null | undefined;
  created?: UserCouponFilterCreated | null | undefined;
  not?: ReadonlyArray<UserCouponFilterInput> | null | undefined;
  or?: ReadonlyArray<UserCouponFilterInput> | null | undefined;
  organizationId?: UserCouponFilterOrganizationId | null | undefined;
  removedOn?: UserCouponFilterRemovedOn | null | undefined;
  systemId?: UserCouponFilterSystemId | null | undefined;
  timesUsed?: UserCouponFilterTimesUsed | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: UserCouponFilterUserId | null | undefined;
  userOldId?: UserCouponFilterUserOldId | null | undefined;
};
export type UserCouponFilterAssignedBy = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserCouponFilterCouponOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserCouponFilterCreated = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserCouponFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserCouponFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserCouponFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserCouponFilterTimesUsed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserFilterInput = {
  amountDue?: UserFilterAmountDue | null | undefined;
  and?: ReadonlyArray<UserFilterInput> | null | undefined;
  authStatus?: UserFilterAuthStatus | null | undefined;
  autoGenNumber?: UserFilterAutoGenNumber | null | undefined;
  charges?: ChargeFilterInput | null | undefined;
  communicationLogs?: CommunicationLogFilterInput | null | undefined;
  createdOn?: UserFilterCreatedOn | null | undefined;
  deletedOn?: UserFilterDeletedOn | null | undefined;
  delinquent?: UserFilterDelinquent | null | undefined;
  devices?: DeviceFilterInput | null | undefined;
  errorReports?: SupportTicketFilterInput | null | undefined;
  firstName?: UserFilterFirstName | null | undefined;
  fullName?: UserFilterFullName | null | undefined;
  id?: UserFilterId | null | undefined;
  joined?: UserFilterJoined | null | undefined;
  language?: UserFilterLanguage | null | undefined;
  lastName?: UserFilterLastName | null | undefined;
  not?: ReadonlyArray<UserFilterInput> | null | undefined;
  or?: ReadonlyArray<UserFilterInput> | null | undefined;
  phone?: UserFilterPhone | null | undefined;
  region?: UserFilterRegion | null | undefined;
  rentals?: RentalFilterInput | null | undefined;
  rfidCards?: RfidCardFilterInput | null | undefined;
  stripeCustomerId?: UserFilterStripeCustomerId | null | undefined;
  userCoupons?: UserCouponFilterInput | null | undefined;
  userMemberships?: UserMembershipFilterInput | null | undefined;
  userSystems?: UserSystemFilterInput | null | undefined;
  userWallets?: UserWalletFilterInput | null | undefined;
  walletTransactions?: WalletTransactionFilterInput | null | undefined;
};
export type UserFilterAmountDue = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserFilterAuthStatus = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserFilterAutoGenNumber = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserFilterDeletedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserFilterDelinquent = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type DeviceFilterInput = {
  admin?: AdminUserFilterInput | null | undefined;
  adminId?: DeviceFilterAdminId | null | undefined;
  and?: ReadonlyArray<DeviceFilterInput> | null | undefined;
  appVersion?: DeviceFilterAppVersion | null | undefined;
  brand?: DeviceFilterBrand | null | undefined;
  carrier?: DeviceFilterCarrier | null | undefined;
  deviceType?: DeviceFilterDeviceType | null | undefined;
  id?: DeviceFilterId | null | undefined;
  lastAuthorized?: DeviceFilterLastAuthorized | null | undefined;
  manufacturer?: DeviceFilterManufacturer | null | undefined;
  model?: DeviceFilterModel | null | undefined;
  not?: ReadonlyArray<DeviceFilterInput> | null | undefined;
  or?: ReadonlyArray<DeviceFilterInput> | null | undefined;
  os?: DeviceFilterOs | null | undefined;
  osVersion?: DeviceFilterOsVersion | null | undefined;
  rentalsEnded?: RentalFilterInput | null | undefined;
  rentalsStarted?: RentalFilterInput | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: DeviceFilterUserId | null | undefined;
  userOldId?: DeviceFilterUserOldId | null | undefined;
  whiteLabelId?: DeviceFilterWhiteLabelId | null | undefined;
};
export type DeviceFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type DeviceFilterAppVersion = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterBrand = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterCarrier = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterDeviceType = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type DeviceFilterId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterLastAuthorized = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type DeviceFilterManufacturer = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterModel = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterOs = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterOsVersion = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DeviceFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type DeviceFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type DeviceFilterWhiteLabelId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterInput = {
  and?: ReadonlyArray<SupportTicketFilterInput> | null | undefined;
  closedDate?: SupportTicketFilterClosedDate | null | undefined;
  content?: SupportTicketFilterContent | null | undefined;
  created?: SupportTicketFilterCreated | null | undefined;
  deviceId?: SupportTicketFilterDeviceId | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareOldId?: SupportTicketFilterHardwareOldId | null | undefined;
  id?: SupportTicketFilterId | null | undefined;
  maintenanceTickets?: MaintenanceTicketFilterInput | null | undefined;
  moduleId?: SupportTicketFilterModuleId | null | undefined;
  not?: ReadonlyArray<SupportTicketFilterInput> | null | undefined;
  notes?: SupportTicketFilterNotes | null | undefined;
  oldId?: SupportTicketFilterOldId | null | undefined;
  or?: ReadonlyArray<SupportTicketFilterInput> | null | undefined;
  organizationId?: SupportTicketFilterOrganizationId | null | undefined;
  owner?: SupportTicketFilterOwner | null | undefined;
  rental?: RentalFilterInput | null | undefined;
  rentalOldId?: SupportTicketFilterRentalOldId | null | undefined;
  state?: SupportTicketFilterState | null | undefined;
  subtype?: SupportTicketFilterSubtype | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: SupportTicketFilterSystemId | null | undefined;
  systemOldId?: SupportTicketFilterSystemOldId | null | undefined;
  type?: SupportTicketFilterType | null | undefined;
  user?: UserFilterInput | null | undefined;
  userOldId?: SupportTicketFilterUserOldId | null | undefined;
};
export type SupportTicketFilterClosedDate = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SupportTicketFilterContent = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketFilterCreated = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SupportTicketFilterDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketFilterHardwareOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterInput = {
  and?: ReadonlyArray<MaintenanceTicketFilterInput> | null | undefined;
  assignee?: MaintenanceTicketFilterAssignee | null | undefined;
  assigneeUser?: AdminUserFilterInput | null | undefined;
  canceledOn?: MaintenanceTicketFilterCanceledOn | null | undefined;
  completedOn?: MaintenanceTicketFilterCompletedOn | null | undefined;
  createdOn?: MaintenanceTicketFilterCreatedOn | null | undefined;
  data?: MaintenanceTicketFilterData | null | undefined;
  description?: MaintenanceTicketFilterDescription | null | undefined;
  dueOn?: MaintenanceTicketFilterDueOn | null | undefined;
  errorReport?: SupportTicketFilterInput | null | undefined;
  errorReportOldId?: MaintenanceTicketFilterErrorReportOldId | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareOldId?: MaintenanceTicketFilterHardwareOldId | null | undefined;
  id?: MaintenanceTicketFilterId | null | undefined;
  isCanceled?: MaintenanceTicketFilterIsCanceled | null | undefined;
  isCompleted?: MaintenanceTicketFilterIsCompleted | null | undefined;
  isOpen?: MaintenanceTicketFilterIsOpen | null | undefined;
  isSafetyTicket?: MaintenanceTicketFilterIsSafetyTicket | null | undefined;
  logs?: MaintenanceLogFilterInput | null | undefined;
  maintenanceTask?: MaintenanceTaskFilterInput | null | undefined;
  maintenanceTaskId?: MaintenanceTicketFilterMaintenanceTaskId | null | undefined;
  not?: ReadonlyArray<MaintenanceTicketFilterInput> | null | undefined;
  oldId?: MaintenanceTicketFilterOldId | null | undefined;
  or?: ReadonlyArray<MaintenanceTicketFilterInput> | null | undefined;
  organizationId?: MaintenanceTicketFilterOrganizationId | null | undefined;
  priority?: MaintenanceTicketFilterPriority | null | undefined;
  rental?: RentalFilterInput | null | undefined;
  rentalOldId?: MaintenanceTicketFilterRentalOldId | null | undefined;
  reporter?: MaintenanceTicketFilterReporter | null | undefined;
  reporterUser?: AdminUserFilterInput | null | undefined;
  sourceType?: MaintenanceTicketFilterSourceType | null | undefined;
  status?: MaintenanceTicketFilterStatus | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: MaintenanceTicketFilterSystemId | null | undefined;
  systemOldId?: MaintenanceTicketFilterSystemOldId | null | undefined;
};
export type MaintenanceTicketFilterAssignee = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTicketFilterCanceledOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketFilterCompletedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketFilterData = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTicketFilterDueOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketFilterErrorReportOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterHardwareOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterIsCanceled = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MaintenanceTicketFilterIsCompleted = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MaintenanceTicketFilterIsOpen = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MaintenanceTicketFilterIsSafetyTicket = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MaintenanceLogFilterInput = {
  adminUser?: AdminUserFilterInput | null | undefined;
  adminUserId?: MaintenanceLogFilterAdminUserId | null | undefined;
  and?: ReadonlyArray<MaintenanceLogFilterInput> | null | undefined;
  createdOn?: MaintenanceLogFilterCreatedOn | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareOldId?: MaintenanceLogFilterHardwareOldId | null | undefined;
  id?: MaintenanceLogFilterId | null | undefined;
  location?: LocationFilterInput | null | undefined;
  locationId?: MaintenanceLogFilterLocationId | null | undefined;
  maintenanceTask?: MaintenanceTaskFilterInput | null | undefined;
  maintenanceTaskOldId?: MaintenanceLogFilterMaintenanceTaskOldId | null | undefined;
  maintenanceTicket?: MaintenanceTicketFilterInput | null | undefined;
  maintenanceTicketOldId?: MaintenanceLogFilterMaintenanceTicketOldId | null | undefined;
  not?: ReadonlyArray<MaintenanceLogFilterInput> | null | undefined;
  notes?: MaintenanceLogFilterNotes | null | undefined;
  oldId?: MaintenanceLogFilterOldId | null | undefined;
  or?: ReadonlyArray<MaintenanceLogFilterInput> | null | undefined;
  organizationId?: MaintenanceLogFilterOrganizationId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: MaintenanceLogFilterSystemId | null | undefined;
  systemOldId?: MaintenanceLogFilterSystemOldId | null | undefined;
  timeTracking?: MaintenanceLogFilterTimeTracking | null | undefined;
  validationData?: MaintenanceLogFilterValidationData | null | undefined;
};
export type MaintenanceLogFilterAdminUserId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceLogFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceLogFilterHardwareOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceLogFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterInput = {
  and?: ReadonlyArray<LocationFilterInput> | null | undefined;
  availableHardwareCount?: LocationFilterAvailableHardwareCount | null | undefined;
  avgRentalsEndedPerUser?: LocationFilterAvgRentalsEndedPerUser | null | undefined;
  avgRentalsStartedPerUser?: LocationFilterAvgRentalsStartedPerUser | null | undefined;
  bannerId?: LocationFilterBannerId | null | undefined;
  capacity?: LocationFilterCapacity | null | undefined;
  configuration?: LocationFilterConfiguration | null | undefined;
  createdOn?: LocationFilterCreatedOn | null | undefined;
  distance?: LocationFilterDistance | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  icon?: ImageFilterInput | null | undefined;
  iconId?: LocationFilterIconId | null | undefined;
  id?: LocationFilterId | null | undefined;
  isActive?: LocationFilterIsActive | null | undefined;
  isWithinBounds?: LocationFilterIsWithinBounds | null | undefined;
  lat?: LocationFilterLat | null | undefined;
  lng?: LocationFilterLng | null | undefined;
  maxReservations?: LocationFilterMaxReservations | null | undefined;
  module?: LocationFilterModule | null | undefined;
  name?: LocationFilterName | null | undefined;
  not?: ReadonlyArray<LocationFilterInput> | null | undefined;
  oldId?: LocationFilterOldId | null | undefined;
  operatingHours?: LocationFilterOperatingHours | null | undefined;
  or?: ReadonlyArray<LocationFilterInput> | null | undefined;
  organizationId?: LocationFilterOrganizationId | null | undefined;
  preventEndingRentals?: LocationFilterPreventEndingRentals | null | undefined;
  preventStartingRentals?: LocationFilterPreventStartingRentals | null | undefined;
  private?: LocationFilterPrivate | null | undefined;
  privatePerks?: PerkFilterInput | null | undefined;
  qrCode?: QrCodeFilterInput | null | undefined;
  radius?: LocationFilterRadius | null | undefined;
  rateConfigurations?: RateConfigurationFilterInput | null | undefined;
  rentalsEnded?: RentalFilterInput | null | undefined;
  rentalsEndedCount?: LocationFilterRentalsEndedCount | null | undefined;
  rentalsStarted?: RentalFilterInput | null | undefined;
  rentalsStartedCount?: LocationFilterRentalsStartedCount | null | undefined;
  reservations?: LocationFilterReservations | null | undefined;
  slowZoneSpeed?: LocationFilterSlowZoneSpeed | null | undefined;
  state?: LocationFilterState | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: LocationFilterSystemId | null | undefined;
  systemOldId?: LocationFilterSystemOldId | null | undefined;
  totalHardwareCount?: LocationFilterTotalHardwareCount | null | undefined;
  totalRentableHardwareCount?: LocationFilterTotalRentableHardwareCount | null | undefined;
  uniqueUsersEndedCount?: LocationFilterUniqueUsersEndedCount | null | undefined;
  uniqueUsersStartedCount?: LocationFilterUniqueUsersStartedCount | null | undefined;
  zoneType?: LocationFilterZoneType | null | undefined;
};
export type LocationFilterAvailableHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterAvgRentalsEndedPerUser = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterAvgRentalsStartedPerUser = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterBannerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterCapacity = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterConfiguration = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type LocationFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type LocationFilterDistance = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  input?: LocationDistanceFieldInput | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationDistanceFieldInput = {
  lat: number;
  lng: number;
};
export type ImageFilterInput = {
  and?: ReadonlyArray<ImageFilterInput> | null | undefined;
  approvedOn?: ImageFilterApprovedOn | null | undefined;
  comment?: ImageFilterComment | null | undefined;
  created?: ImageFilterCreated | null | undefined;
  id?: ImageFilterId | null | undefined;
  name?: ImageFilterName | null | undefined;
  not?: ReadonlyArray<ImageFilterInput> | null | undefined;
  oldId?: ImageFilterOldId | null | undefined;
  or?: ReadonlyArray<ImageFilterInput> | null | undefined;
  rejected?: ImageFilterRejected | null | undefined;
  type?: ImageFilterType | null | undefined;
};
export type ImageFilterApprovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ImageFilterComment = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ImageFilterCreated = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ImageFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ImageFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ImageFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ImageFilterRejected = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ImageFilterType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type LocationFilterIconId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterIsActive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type LocationFilterIsWithinBounds = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  input?: LocationIsWithinBoundsFieldInput | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type LocationIsWithinBoundsFieldInput = {
  lat: number;
  lng: number;
};
export type LocationFilterLat = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterLng = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterMaxReservations = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterModule = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type LocationFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type LocationFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterOperatingHours = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type LocationFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterPreventEndingRentals = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type LocationFilterPreventStartingRentals = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type LocationFilterPrivate = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type PerkFilterInput = {
  activeOn?: PerkFilterActiveOn | null | undefined;
  and?: ReadonlyArray<PerkFilterInput> | null | undefined;
  archived?: PerkFilterArchived | null | undefined;
  archivedOn?: PerkFilterArchivedOn | null | undefined;
  createdOn?: PerkFilterCreatedOn | null | undefined;
  discount?: PerkFilterDiscount | null | undefined;
  durationMoneyOff?: PerkFilterDurationMoneyOff | null | undefined;
  freeTime?: PerkFilterFreeTime | null | undefined;
  id?: PerkFilterId | null | undefined;
  isActive?: PerkFilterIsActive | null | undefined;
  location?: LocationFilterInput | null | undefined;
  locationId?: PerkFilterLocationId | null | undefined;
  membership?: MembershipFilterInput | null | undefined;
  membershipOldId?: PerkFilterMembershipOldId | null | undefined;
  minutes?: PerkFilterMinutes | null | undefined;
  moneyOff?: PerkFilterMoneyOff | null | undefined;
  noFlex?: PerkFilterNoFlex | null | undefined;
  not?: ReadonlyArray<PerkFilterInput> | null | undefined;
  oldId?: PerkFilterOldId | null | undefined;
  or?: ReadonlyArray<PerkFilterInput> | null | undefined;
  organizationId?: PerkFilterOrganizationId | null | undefined;
  partnerId?: PerkFilterPartnerId | null | undefined;
  reservation?: PerkFilterReservation | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: PerkFilterSystemId | null | undefined;
  systemOldId?: PerkFilterSystemOldId | null | undefined;
  unlocks?: PerkFilterUnlocks | null | undefined;
  waiveBaseRate?: PerkFilterWaiveBaseRate | null | undefined;
};
export type PerkFilterActiveOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type PerkFilterArchived = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type PerkFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type PerkFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type PerkFilterDiscount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type PerkFilterDurationMoneyOff = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type PerkFilterFreeTime = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type PerkFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PerkFilterIsActive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type PerkFilterLocationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterInput = {
  activeOn?: MembershipFilterActiveOn | null | undefined;
  and?: ReadonlyArray<MembershipFilterInput> | null | undefined;
  archivedOn?: MembershipFilterArchivedOn | null | undefined;
  authExpiration?: MembershipFilterAuthExpiration | null | undefined;
  authType?: MembershipFilterAuthType | null | undefined;
  brandingColor?: MembershipFilterBrandingColor | null | undefined;
  createdOn?: MembershipFilterCreatedOn | null | undefined;
  creditCardHold?: MembershipFilterCreditCardHold | null | undefined;
  data?: MembershipFilterData | null | undefined;
  hidden?: MembershipFilterHidden | null | undefined;
  hideValidEmails?: MembershipFilterHideValidEmails | null | undefined;
  id?: MembershipFilterId | null | undefined;
  isActive?: MembershipFilterIsActive | null | undefined;
  isArchived?: MembershipFilterIsArchived | null | undefined;
  isFuture?: MembershipFilterIsFuture | null | undefined;
  logoImageId?: MembershipFilterLogoImageId | null | undefined;
  maxRentals?: MembershipFilterMaxRentals | null | undefined;
  minimumWalletDeposit?: MembershipFilterMinimumWalletDeposit | null | undefined;
  monthlyCost?: MembershipFilterMonthlyCost | null | undefined;
  name?: MembershipFilterName | null | undefined;
  not?: ReadonlyArray<MembershipFilterInput> | null | undefined;
  oldId?: MembershipFilterOldId | null | undefined;
  or?: ReadonlyArray<MembershipFilterInput> | null | undefined;
  organizationId?: MembershipFilterOrganizationId | null | undefined;
  password?: MembershipFilterPassword | null | undefined;
  perks?: PerkFilterInput | null | undefined;
  prices?: MembershipPriceFilterInput | null | undefined;
  priority?: MembershipFilterPriority | null | undefined;
  qrCode?: QrCodeFilterInput | null | undefined;
  replacementMembership?: MembershipFilterInput | null | undefined;
  replacementMembershipOldId?: MembershipFilterReplacementMembershipOldId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: MembershipFilterSystemId | null | undefined;
  systemOldId?: MembershipFilterSystemOldId | null | undefined;
  yearlyCost?: MembershipFilterYearlyCost | null | undefined;
};
export type MembershipFilterActiveOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipFilterAuthExpiration = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MembershipFilterAuthType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MembershipFilterBrandingColor = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MembershipFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipFilterCreditCardHold = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipFilterData = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipFilterHidden = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MembershipFilterHideValidEmails = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MembershipFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterIsActive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MembershipFilterIsArchived = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MembershipFilterIsFuture = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MembershipFilterLogoImageId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterMaxRentals = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipFilterMinimumWalletDeposit = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipFilterMonthlyCost = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MembershipFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterPassword = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MembershipPriceFilterInput = {
  activeOn?: MembershipPriceFilterActiveOn | null | undefined;
  and?: ReadonlyArray<MembershipPriceFilterInput> | null | undefined;
  archivedOn?: MembershipPriceFilterArchivedOn | null | undefined;
  autoRenews?: MembershipPriceFilterAutoRenews | null | undefined;
  createdOn?: MembershipPriceFilterCreatedOn | null | undefined;
  id?: MembershipPriceFilterId | null | undefined;
  membership?: MembershipFilterInput | null | undefined;
  membershipId?: MembershipPriceFilterMembershipId | null | undefined;
  minutes?: MembershipPriceFilterMinutes | null | undefined;
  name?: MembershipPriceFilterName | null | undefined;
  not?: ReadonlyArray<MembershipPriceFilterInput> | null | undefined;
  or?: ReadonlyArray<MembershipPriceFilterInput> | null | undefined;
  organizationId?: MembershipPriceFilterOrganizationId | null | undefined;
  price?: MembershipPriceFilterPrice | null | undefined;
  priority?: MembershipPriceFilterPriority | null | undefined;
  renewalInterval?: MembershipPriceFilterRenewalInterval | null | undefined;
  replacedByMembershipPrice?: MembershipPriceFilterInput | null | undefined;
  systemId?: MembershipPriceFilterSystemId | null | undefined;
  termEndsOn?: MembershipPriceFilterTermEndsOn | null | undefined;
  termStartsOn?: MembershipPriceFilterTermStartsOn | null | undefined;
  unlocks?: MembershipPriceFilterUnlocks | null | undefined;
};
export type MembershipPriceFilterActiveOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipPriceFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipPriceFilterAutoRenews = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MembershipPriceFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipPriceFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipPriceFilterMembershipId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipPriceFilterMinutes = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipPriceFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MembershipPriceFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipPriceFilterPrice = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipPriceFilterPriority = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipPriceFilterRenewalInterval = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipPriceFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipPriceFilterTermEndsOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipPriceFilterTermStartsOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MembershipPriceFilterUnlocks = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MembershipFilterPriority = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type QrCodeFilterInput = {
  and?: ReadonlyArray<QrCodeFilterInput> | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareOldId?: QrCodeFilterHardwareOldId | null | undefined;
  id?: QrCodeFilterId | null | undefined;
  location?: LocationFilterInput | null | undefined;
  locationOldId?: QrCodeFilterLocationOldId | null | undefined;
  membership?: MembershipFilterInput | null | undefined;
  membershipId?: QrCodeFilterMembershipId | null | undefined;
  not?: ReadonlyArray<QrCodeFilterInput> | null | undefined;
  or?: ReadonlyArray<QrCodeFilterInput> | null | undefined;
  organizationId?: QrCodeFilterOrganizationId | null | undefined;
  systemId?: QrCodeFilterSystemId | null | undefined;
};
export type QrCodeFilterHardwareOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type QrCodeFilterLocationOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeFilterMembershipId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterReplacementMembershipOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MembershipFilterYearlyCost = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type PerkFilterMembershipOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PerkFilterMinutes = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type PerkFilterMoneyOff = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type PerkFilterNoFlex = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type PerkFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PerkFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PerkFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PerkFilterReservation = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type PerkFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PerkFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type PerkFilterUnlocks = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type PerkFilterWaiveBaseRate = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type LocationFilterRadius = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateConfigurationFilterInput = {
  and?: ReadonlyArray<RateConfigurationFilterInput> | null | undefined;
  configuration?: RateConfigurationFilterConfiguration | null | undefined;
  createdOn?: RateConfigurationFilterCreatedOn | null | undefined;
  id?: RateConfigurationFilterId | null | undefined;
  location?: LocationFilterInput | null | undefined;
  not?: ReadonlyArray<RateConfigurationFilterInput> | null | undefined;
  or?: ReadonlyArray<RateConfigurationFilterInput> | null | undefined;
  organizationId?: RateConfigurationFilterOrganizationId | null | undefined;
  partnerId?: RateConfigurationFilterPartnerId | null | undefined;
  platformDefault?: RateConfigurationFilterPlatformDefault | null | undefined;
  rate?: RateFilterInput | null | undefined;
  rateId?: RateConfigurationFilterRateId | null | undefined;
  replacedBy?: RateConfigurationFilterReplacedBy | null | undefined;
  replacedByAdmin?: RateConfigurationFilterReplacedByAdmin | null | undefined;
  replacedOn?: RateConfigurationFilterReplacedOn | null | undefined;
  stationId?: RateConfigurationFilterStationId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: RateConfigurationFilterSystemId | null | undefined;
};
export type RateConfigurationFilterConfiguration = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RateConfigurationFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RateConfigurationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterPlatformDefault = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RateFilterInput = {
  activeOn?: RateFilterActiveOn | null | undefined;
  and?: ReadonlyArray<RateFilterInput> | null | undefined;
  archivedOn?: RateFilterArchivedOn | null | undefined;
  baseRate?: RateFilterBaseRate | null | undefined;
  baseRateIncludedTime?: RateFilterBaseRateIncludedTime | null | undefined;
  createdOn?: RateFilterCreatedOn | null | undefined;
  creditCardHold?: RateFilterCreditCardHold | null | undefined;
  freeTime?: RateFilterFreeTime | null | undefined;
  hidden?: RateFilterHidden | null | undefined;
  id?: RateFilterId | null | undefined;
  maxPeriods?: RateFilterMaxPeriods | null | undefined;
  maxRentals?: RateFilterMaxRentals | null | undefined;
  membershipRequired?: RateFilterMembershipRequired | null | undefined;
  minimumWalletDeposit?: RateFilterMinimumWalletDeposit | null | undefined;
  name?: RateFilterName | null | undefined;
  not?: ReadonlyArray<RateFilterInput> | null | undefined;
  oldId?: RateFilterOldId | null | undefined;
  or?: ReadonlyArray<RateFilterInput> | null | undefined;
  organizationId?: RateFilterOrganizationId | null | undefined;
  periodDuration?: RateFilterPeriodDuration | null | undefined;
  pricePerPeriod?: RateFilterPricePerPeriod | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: RateFilterSystemId | null | undefined;
  systemOldId?: RateFilterSystemOldId | null | undefined;
};
export type RateFilterActiveOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RateFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RateFilterBaseRate = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterBaseRateIncludedTime = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RateFilterCreditCardHold = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterFreeTime = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterHidden = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RateFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateFilterMaxPeriods = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterMaxRentals = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterMembershipRequired = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RateFilterMinimumWalletDeposit = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RateFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateFilterPeriodDuration = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterPricePerPeriod = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RateFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterRateId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterReplacedBy = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterReplacedByAdmin = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterReplacedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RateConfigurationFilterStationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RateConfigurationFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterRentalsEndedCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterRentalsStartedCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterReservations = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type LocationFilterSlowZoneSpeed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterState = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type LocationFilterTotalHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterTotalRentableHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterUniqueUsersEndedCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterUniqueUsersStartedCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type LocationFilterZoneType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceLogFilterLocationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTaskFilterInput = {
  and?: ReadonlyArray<MaintenanceTaskFilterInput> | null | undefined;
  archivedOn?: MaintenanceTaskFilterArchivedOn | null | undefined;
  createdOn?: MaintenanceTaskFilterCreatedOn | null | undefined;
  description?: MaintenanceTaskFilterDescription | null | undefined;
  id?: MaintenanceTaskFilterId | null | undefined;
  instructions?: MaintenanceTaskFilterInstructions | null | undefined;
  isSafetyTask?: MaintenanceTaskFilterIsSafetyTask | null | undefined;
  logs?: MaintenanceLogFilterInput | null | undefined;
  maintenanceTickets?: MaintenanceTicketFilterInput | null | undefined;
  name?: MaintenanceTaskFilterName | null | undefined;
  not?: ReadonlyArray<MaintenanceTaskFilterInput> | null | undefined;
  oldId?: MaintenanceTaskFilterOldId | null | undefined;
  or?: ReadonlyArray<MaintenanceTaskFilterInput> | null | undefined;
  organizationId?: MaintenanceTaskFilterOrganizationId | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerOldId?: MaintenanceTaskFilterPartnerOldId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: MaintenanceTaskFilterSystemId | null | undefined;
  systemOldId?: MaintenanceTaskFilterSystemOldId | null | undefined;
  taskType?: MaintenanceTaskFilterTaskType | null | undefined;
  timeEstimate?: MaintenanceTaskFilterTimeEstimate | null | undefined;
};
export type MaintenanceTaskFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTaskFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTaskFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTaskFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTaskFilterInstructions = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTaskFilterIsSafetyTask = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type MaintenanceTaskFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTaskFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTaskFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTaskFilterPartnerOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTaskFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTaskFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTaskFilterTaskType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTaskFilterTimeEstimate = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MaintenanceLogFilterMaintenanceTaskOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceLogFilterMaintenanceTicketOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceLogFilterNotes = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceLogFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceLogFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceLogFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceLogFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceLogFilterTimeTracking = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MaintenanceLogFilterValidationData = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketFilterMaintenanceTaskId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterPriority = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MaintenanceTicketFilterRentalOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterReporter = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTicketFilterSourceType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTicketFilterStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTicketFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterModuleId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketFilterNotes = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterOwner = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketFilterRentalOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterState = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SupportTicketFilterSubtype = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketFilterType = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SupportTicketFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserFilterFirstName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserFilterFullName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserFilterJoined = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserFilterLanguage = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserFilterLastName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserFilterPhone = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserFilterRegion = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RfidCardFilterInput = {
  and?: ReadonlyArray<RfidCardFilterInput> | null | undefined;
  archivedOn?: RfidCardFilterArchivedOn | null | undefined;
  cardId?: RfidCardFilterCardId | null | undefined;
  createdOn?: RfidCardFilterCreatedOn | null | undefined;
  id?: RfidCardFilterId | null | undefined;
  isActive?: RfidCardFilterIsActive | null | undefined;
  label?: RfidCardFilterLabel | null | undefined;
  not?: ReadonlyArray<RfidCardFilterInput> | null | undefined;
  or?: ReadonlyArray<RfidCardFilterInput> | null | undefined;
  rentalCount?: RfidCardFilterRentalCount | null | undefined;
  userId?: RfidCardFilterUserId | null | undefined;
};
export type RfidCardFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RfidCardFilterCardId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RfidCardFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RfidCardFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RfidCardFilterIsActive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RfidCardFilterLabel = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RfidCardFilterRentalCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RfidCardFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserFilterStripeCustomerId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserMembershipFilterInput = {
  additionalMinutes?: UserMembershipFilterAdditionalMinutes | null | undefined;
  additionalUnlocks?: UserMembershipFilterAdditionalUnlocks | null | undefined;
  adminCancellationReason?: UserMembershipFilterAdminCancellationReason | null | undefined;
  and?: ReadonlyArray<UserMembershipFilterInput> | null | undefined;
  approvedOn?: UserMembershipFilterApprovedOn | null | undefined;
  cancelationType?: UserMembershipFilterCancelationType | null | undefined;
  canceledByAdmin?: UserMembershipFilterCanceledByAdmin | null | undefined;
  canceledByAdminUser?: AdminUserFilterInput | null | undefined;
  canceledOn?: UserMembershipFilterCanceledOn | null | undefined;
  createdOn?: UserMembershipFilterCreatedOn | null | undefined;
  data?: UserMembershipFilterData | null | undefined;
  dismissedOn?: UserMembershipFilterDismissedOn | null | undefined;
  email?: UserMembershipFilterEmail | null | undefined;
  expiresOn?: UserMembershipFilterExpiresOn | null | undefined;
  failedRenewalAttempts?: UserMembershipFilterFailedRenewalAttempts | null | undefined;
  freeRenewals?: UserMembershipFilterFreeRenewals | null | undefined;
  id?: UserMembershipFilterId | null | undefined;
  isActive?: UserMembershipFilterIsActive | null | undefined;
  isApproved?: UserMembershipFilterIsApproved | null | undefined;
  isCanceled?: UserMembershipFilterIsCanceled | null | undefined;
  isConvertedToReplacement?: UserMembershipFilterIsConvertedToReplacement | null | undefined;
  isDismissed?: UserMembershipFilterIsDismissed | null | undefined;
  isExpired?: UserMembershipFilterIsExpired | null | undefined;
  isPending?: UserMembershipFilterIsPending | null | undefined;
  isRejected?: UserMembershipFilterIsRejected | null | undefined;
  lastCharged?: UserMembershipFilterLastCharged | null | undefined;
  membership?: MembershipFilterInput | null | undefined;
  membershipOldId?: UserMembershipFilterMembershipOldId | null | undefined;
  membershipPrice?: MembershipPriceFilterInput | null | undefined;
  membershipPriceId?: UserMembershipFilterMembershipPriceId | null | undefined;
  minutesLeft?: UserMembershipFilterMinutesLeft | null | undefined;
  minutesTotal?: UserMembershipFilterMinutesTotal | null | undefined;
  minutesUsed?: UserMembershipFilterMinutesUsed | null | undefined;
  not?: ReadonlyArray<UserMembershipFilterInput> | null | undefined;
  oldId?: UserMembershipFilterOldId | null | undefined;
  or?: ReadonlyArray<UserMembershipFilterInput> | null | undefined;
  organizationId?: UserMembershipFilterOrganizationId | null | undefined;
  paidRenewals?: UserMembershipFilterPaidRenewals | null | undefined;
  paidUntil?: UserMembershipFilterPaidUntil | null | undefined;
  priority?: UserMembershipFilterPriority | null | undefined;
  rejectedOn?: UserMembershipFilterRejectedOn | null | undefined;
  rejectionReason?: UserMembershipFilterRejectionReason | null | undefined;
  renewable?: UserMembershipFilterRenewable | null | undefined;
  renewedDuration?: UserMembershipFilterRenewedDuration | null | undefined;
  renewedTimes?: UserMembershipFilterRenewedTimes | null | undefined;
  renewsOn?: UserMembershipFilterRenewsOn | null | undefined;
  systemId?: UserMembershipFilterSystemId | null | undefined;
  unlocksLeft?: UserMembershipFilterUnlocksLeft | null | undefined;
  unlocksTotal?: UserMembershipFilterUnlocksTotal | null | undefined;
  unlocksUsed?: UserMembershipFilterUnlocksUsed | null | undefined;
  usage?: UserMembershipUsageFilterInput | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: UserMembershipFilterUserId | null | undefined;
  userOldId?: UserMembershipFilterUserOldId | null | undefined;
};
export type UserMembershipFilterAdditionalMinutes = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterAdditionalUnlocks = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterAdminCancellationReason = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserMembershipFilterApprovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterCancelationType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserMembershipFilterCanceledByAdmin = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterCanceledOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterData = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterDismissedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterEmail = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserMembershipFilterExpiresOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterFailedRenewalAttempts = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterFreeRenewals = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterIsActive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterIsApproved = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterIsCanceled = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterIsConvertedToReplacement = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterIsDismissed = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterIsExpired = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterIsPending = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterIsRejected = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterLastCharged = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterMembershipOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterMembershipPriceId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterMinutesLeft = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterMinutesTotal = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterMinutesUsed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterPaidRenewals = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterPaidUntil = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterPriority = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterRejectedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterRejectionReason = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserMembershipFilterRenewable = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserMembershipFilterRenewedDuration = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserMembershipFilterRenewedTimes = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterRenewsOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterUnlocksLeft = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterUnlocksTotal = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipFilterUnlocksUsed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipUsageFilterInput = {
  additionalMinutes?: UserMembershipUsageFilterAdditionalMinutes | null | undefined;
  additionalUnlocks?: UserMembershipUsageFilterAdditionalUnlocks | null | undefined;
  and?: ReadonlyArray<UserMembershipUsageFilterInput> | null | undefined;
  createdOn?: UserMembershipUsageFilterCreatedOn | null | undefined;
  gid?: UserMembershipUsageFilterGid | null | undefined;
  membershipPrice?: MembershipPriceFilterInput | null | undefined;
  membershipPriceId?: UserMembershipUsageFilterMembershipPriceId | null | undefined;
  minutesUsed?: UserMembershipUsageFilterMinutesUsed | null | undefined;
  not?: ReadonlyArray<UserMembershipUsageFilterInput> | null | undefined;
  or?: ReadonlyArray<UserMembershipUsageFilterInput> | null | undefined;
  perk?: PerkFilterInput | null | undefined;
  perkId?: UserMembershipUsageFilterPerkId | null | undefined;
  unlockCount?: UserMembershipUsageFilterUnlockCount | null | undefined;
  updatedOn?: UserMembershipUsageFilterUpdatedOn | null | undefined;
  userMembership?: UserMembershipFilterInput | null | undefined;
  userMembershipId?: UserMembershipUsageFilterUserMembershipId | null | undefined;
};
export type UserMembershipUsageFilterAdditionalMinutes = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipUsageFilterAdditionalUnlocks = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipUsageFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipUsageFilterGid = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipUsageFilterMembershipPriceId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipUsageFilterMinutesUsed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipUsageFilterPerkId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipUsageFilterUnlockCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserMembershipUsageFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserMembershipUsageFilterUserMembershipId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserMembershipFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserSystemFilterInput = {
  acceptedTosOn?: UserSystemFilterAcceptedTosOn | null | undefined;
  and?: ReadonlyArray<UserSystemFilterInput> | null | undefined;
  blacklisted?: UserSystemFilterBlacklisted | null | undefined;
  hidden?: UserSystemFilterHidden | null | undefined;
  joined?: UserSystemFilterJoined | null | undefined;
  not?: ReadonlyArray<UserSystemFilterInput> | null | undefined;
  or?: ReadonlyArray<UserSystemFilterInput> | null | undefined;
  organizationId?: UserSystemFilterOrganizationId | null | undefined;
  rejected?: UserSystemFilterRejected | null | undefined;
  removed?: UserSystemFilterRemoved | null | undefined;
  systemId?: UserSystemFilterSystemId | null | undefined;
  userId?: UserSystemFilterUserId | null | undefined;
};
export type UserSystemFilterAcceptedTosOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserSystemFilterBlacklisted = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserSystemFilterHidden = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserSystemFilterJoined = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type UserSystemFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserSystemFilterRejected = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserSystemFilterRemoved = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type UserSystemFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserSystemFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserWalletFilterInput = {
  and?: ReadonlyArray<UserWalletFilterInput> | null | undefined;
  balance?: UserWalletFilterBalance | null | undefined;
  currency?: UserWalletFilterCurrency | null | undefined;
  id?: UserWalletFilterId | null | undefined;
  not?: ReadonlyArray<UserWalletFilterInput> | null | undefined;
  or?: ReadonlyArray<UserWalletFilterInput> | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerOldId?: UserWalletFilterPartnerOldId | null | undefined;
  paymentProvider?: UserWalletFilterPaymentProvider | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: UserWalletFilterUserId | null | undefined;
  userOldId?: UserWalletFilterUserOldId | null | undefined;
};
export type UserWalletFilterBalance = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserWalletFilterCurrency = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserWalletFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserWalletFilterPartnerOldId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UserWalletFilterPaymentProvider = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type UserWalletFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserWalletFilterUserOldId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type WalletTransactionFilterInput = {
  amount?: WalletTransactionFilterAmount | null | undefined;
  amountRefunded?: WalletTransactionFilterAmountRefunded | null | undefined;
  and?: ReadonlyArray<WalletTransactionFilterInput> | null | undefined;
  charge?: ChargeFilterInput | null | undefined;
  chargeId?: WalletTransactionFilterChargeId | null | undefined;
  chargeTotal?: WalletTransactionFilterChargeTotal | null | undefined;
  createdOn?: WalletTransactionFilterCreatedOn | null | undefined;
  description?: WalletTransactionFilterDescription | null | undefined;
  id?: WalletTransactionFilterId | null | undefined;
  not?: ReadonlyArray<WalletTransactionFilterInput> | null | undefined;
  oldId?: WalletTransactionFilterOldId | null | undefined;
  or?: ReadonlyArray<WalletTransactionFilterInput> | null | undefined;
  organizationId?: WalletTransactionFilterOrganizationId | null | undefined;
  partner?: WalletTransactionFilterPartner | null | undefined;
  refundDescription?: WalletTransactionFilterRefundDescription | null | undefined;
  refunded?: WalletTransactionFilterRefunded | null | undefined;
  rental?: RentalFilterInput | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: WalletTransactionFilterSystemId | null | undefined;
  systemOldId?: WalletTransactionFilterSystemOldId | null | undefined;
  taxAmount?: WalletTransactionFilterTaxAmount | null | undefined;
  taxRate?: WalletTransactionFilterTaxRate | null | undefined;
  type?: WalletTransactionFilterType | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: WalletTransactionFilterUserId | null | undefined;
  userOldId?: WalletTransactionFilterUserOldId | null | undefined;
  wallet?: UserWalletFilterInput | null | undefined;
  walletId?: WalletTransactionFilterWalletId | null | undefined;
};
export type WalletTransactionFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type WalletTransactionFilterAmountRefunded = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type WalletTransactionFilterChargeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type WalletTransactionFilterChargeTotal = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type WalletTransactionFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type WalletTransactionFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type WalletTransactionFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterPartner = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterRefundDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type WalletTransactionFilterRefunded = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type WalletTransactionFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterTaxAmount = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type WalletTransactionFilterTaxRate = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type WalletTransactionFilterType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type WalletTransactionFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type WalletTransactionFilterWalletId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserCouponFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UserCouponFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CouponFilterUses = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CouponFilterValidDays = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CouponFilterValidFrom = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type CouponFilterValidTimeEnd = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CouponFilterValidTimeStart = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CouponFilterValidUntil = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterCouponId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterData = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterDistance = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterDuration = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterEffectiveGracePeriod = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterEndAdminUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterEndBy = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterEndDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterEndImageUrl = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterEndLat = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterEndLng = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterEndLocationOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterEndParentHardwareId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterEndRack = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterEndTime = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterEndType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterEndUserRfidCardId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterEndedWithinGracePeriod = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RentalFilterFailedStart = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RentalFilterFeesPostTaxAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterForceEndAck = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RentalFilterForceEndTime = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterForceEndType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterGracePeriod = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterHardwareOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterIsVoidCharge = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type RentalFilterMembershipMinutesConsumed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterParkingCredit = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterPaymentMethodId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterPerkOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterRateOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterRating = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterRefundAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterRefundComment = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterReviewStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterStartAdminUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterStartDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterStartLat = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterStartLng = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterStartLocationOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterStartParentHardwareId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterStartRack = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterStartTime = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterStartType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterStartUserRfidCardId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterTaxAmount = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterTaxRate = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterTripDistance = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterUsageSubtotal = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterVoidBy = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalFilterVoidReason = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalFilterVoidedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalFilterWalletTransactionOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterActiveRentalId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterBatteryPercent = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterBatteryVoltage = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterCharging = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareAssignmentFilterInput = {
  and?: ReadonlyArray<HardwareAssignmentFilterInput> | null | undefined;
  child?: HardwareFilterInput | null | undefined;
  childOrganizationId?: HardwareAssignmentFilterChildOrganizationId | null | undefined;
  childSystemId?: HardwareAssignmentFilterChildSystemId | null | undefined;
  createdOn?: HardwareAssignmentFilterCreatedOn | null | undefined;
  hardwareChildId?: HardwareAssignmentFilterHardwareChildId | null | undefined;
  hardwareParentId?: HardwareAssignmentFilterHardwareParentId | null | undefined;
  id?: HardwareAssignmentFilterId | null | undefined;
  not?: ReadonlyArray<HardwareAssignmentFilterInput> | null | undefined;
  or?: ReadonlyArray<HardwareAssignmentFilterInput> | null | undefined;
  parent?: HardwareFilterInput | null | undefined;
  parentOrganizationId?: HardwareAssignmentFilterParentOrganizationId | null | undefined;
  parentSystemId?: HardwareAssignmentFilterParentSystemId | null | undefined;
  removedOn?: HardwareAssignmentFilterRemovedOn | null | undefined;
};
export type HardwareAssignmentFilterChildOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareAssignmentFilterChildSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareAssignmentFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareAssignmentFilterHardwareChildId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareAssignmentFilterHardwareParentId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareAssignmentFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareAssignmentFilterParentOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareAssignmentFilterParentSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareAssignmentFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventFilterInput = {
  and?: ReadonlyArray<EventFilterInput> | null | undefined;
  createdOn?: EventFilterCreatedOn | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareOldId?: EventFilterHardwareOldId | null | undefined;
  id?: EventFilterId | null | undefined;
  message?: EventFilterMessage | null | undefined;
  not?: ReadonlyArray<EventFilterInput> | null | undefined;
  or?: ReadonlyArray<EventFilterInput> | null | undefined;
  organizationId?: EventFilterOrganizationId | null | undefined;
  recordedAt?: EventFilterRecordedAt | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: EventFilterSystemId | null | undefined;
  systemOldId?: EventFilterSystemOldId | null | undefined;
  type?: EventFilterType | null | undefined;
};
export type EventFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventFilterHardwareOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventFilterMessage = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type EventFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventFilterRecordedAt = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventFilterType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterFirmwareVersion = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterInput = {
  and?: ReadonlyArray<HardwareProductFilterInput> | null | undefined;
  createdOn?: HardwareProductFilterCreatedOn | null | undefined;
  description?: HardwareProductFilterDescription | null | undefined;
  hardwareProductVersions?: HardwareProductVersionFilterInput | null | undefined;
  hardwareType?: HardwareTypeFilterInput | null | undefined;
  hardwareTypeId?: HardwareProductFilterHardwareTypeId | null | undefined;
  hasBatteryStatus?: HardwareProductFilterHasBatteryStatus | null | undefined;
  hasBle?: HardwareProductFilterHasBle | null | undefined;
  hasChildren?: HardwareProductFilterHasChildren | null | undefined;
  hasConfig?: HardwareProductFilterHasConfig | null | undefined;
  hasImei?: HardwareProductFilterHasImei | null | undefined;
  hasLocationTracking?: HardwareProductFilterHasLocationTracking | null | undefined;
  hasMac?: HardwareProductFilterHasMac | null | undefined;
  hasNumber?: HardwareProductFilterHasNumber | null | undefined;
  hasStation?: HardwareProductFilterHasStation | null | undefined;
  hasTcpConnection?: HardwareProductFilterHasTcpConnection | null | undefined;
  hasVendorId?: HardwareProductFilterHasVendorId | null | undefined;
  hasVendorSerial?: HardwareProductFilterHasVendorSerial | null | undefined;
  id?: HardwareProductFilterId | null | undefined;
  latestFirmwareVersion?: HardwareProductFilterLatestFirmwareVersion | null | undefined;
  mdsVehicleType?: HardwareProductFilterMdsVehicleType | null | undefined;
  name?: HardwareProductFilterName | null | undefined;
  not?: ReadonlyArray<HardwareProductFilterInput> | null | undefined;
  oldId?: HardwareProductFilterOldId | null | undefined;
  or?: ReadonlyArray<HardwareProductFilterInput> | null | undefined;
  primaryIdentifier?: HardwareProductFilterPrimaryIdentifier | null | undefined;
  releaseRentedChildren?: HardwareProductFilterReleaseRentedChildren | null | undefined;
  rentalProcess?: HardwareProductFilterRentalProcess | null | undefined;
  requireLabel?: HardwareProductFilterRequireLabel | null | undefined;
  supportsBleBatteryLevel?: HardwareProductFilterSupportsBleBatteryLevel | null | undefined;
  supportsBleFirmwareUpdate?: HardwareProductFilterSupportsBleFirmwareUpdate | null | undefined;
  supportsBleFirmwareVersion?: HardwareProductFilterSupportsBleFirmwareVersion | null | undefined;
  supportsBleLock?: HardwareProductFilterSupportsBleLock | null | undefined;
  supportsBleLockStateCheck?: HardwareProductFilterSupportsBleLockStateCheck | null | undefined;
  supportsBleMessageCount?: HardwareProductFilterSupportsBleMessageCount | null | undefined;
  supportsBlePersistentBroadcasting?: HardwareProductFilterSupportsBlePersistentBroadcasting | null | undefined;
  supportsBlePersistentConnection?: HardwareProductFilterSupportsBlePersistentConnection | null | undefined;
  supportsBleUnlock?: HardwareProductFilterSupportsBleUnlock | null | undefined;
  supportsRemoteBatteryLock?: HardwareProductFilterSupportsRemoteBatteryLock | null | undefined;
  supportsRemoteBatteryStatus?: HardwareProductFilterSupportsRemoteBatteryStatus | null | undefined;
  supportsRemoteBatteryUnlock?: HardwareProductFilterSupportsRemoteBatteryUnlock | null | undefined;
  supportsRemoteLocationCheck?: HardwareProductFilterSupportsRemoteLocationCheck | null | undefined;
  supportsRemoteLock?: HardwareProductFilterSupportsRemoteLock | null | undefined;
  supportsRemoteRing?: HardwareProductFilterSupportsRemoteRing | null | undefined;
  supportsRemoteUnlock?: HardwareProductFilterSupportsRemoteUnlock | null | undefined;
  unlockOnChildRental?: HardwareProductFilterUnlockOnChildRental | null | undefined;
  vendor?: HardwareProductFilterVendor | null | undefined;
  vendorSerialDescription?: HardwareProductFilterVendorSerialDescription | null | undefined;
  vendorSerialRegex?: HardwareProductFilterVendorSerialRegex | null | undefined;
  vendorSerialValidationRegex?: HardwareProductFilterVendorSerialValidationRegex | null | undefined;
};
export type HardwareProductFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareProductFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductVersionFilterInput = {
  and?: ReadonlyArray<HardwareProductVersionFilterInput> | null | undefined;
  hardwareProductId?: HardwareProductVersionFilterHardwareProductId | null | undefined;
  id?: HardwareProductVersionFilterId | null | undefined;
  name?: HardwareProductVersionFilterName | null | undefined;
  not?: ReadonlyArray<HardwareProductVersionFilterInput> | null | undefined;
  oldId?: HardwareProductVersionFilterOldId | null | undefined;
  or?: ReadonlyArray<HardwareProductVersionFilterInput> | null | undefined;
};
export type HardwareProductVersionFilterHardwareProductId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductVersionFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductVersionFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductVersionFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareTypeFilterInput = {
  and?: ReadonlyArray<HardwareTypeFilterInput> | null | undefined;
  id?: HardwareTypeFilterId | null | undefined;
  name?: HardwareTypeFilterName | null | undefined;
  namePlural?: HardwareTypeFilterNamePlural | null | undefined;
  not?: ReadonlyArray<HardwareTypeFilterInput> | null | undefined;
  or?: ReadonlyArray<HardwareTypeFilterInput> | null | undefined;
};
export type HardwareTypeFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareTypeFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareTypeFilterNamePlural = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterHardwareTypeId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductFilterHasBatteryStatus = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasBle = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasChildren = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasConfig = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasImei = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasLocationTracking = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasMac = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasNumber = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasStation = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasTcpConnection = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasVendorId = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterHasVendorSerial = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductFilterLatestFirmwareVersion = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterMdsVehicleType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductFilterPrimaryIdentifier = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterReleaseRentedChildren = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterRentalProcess = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareProductFilterRequireLabel = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBleBatteryLevel = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBleFirmwareUpdate = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBleFirmwareVersion = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBleLock = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBleLockStateCheck = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBleMessageCount = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBlePersistentBroadcasting = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBlePersistentConnection = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsBleUnlock = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsRemoteBatteryLock = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsRemoteBatteryStatus = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsRemoteBatteryUnlock = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsRemoteLocationCheck = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsRemoteLock = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsRemoteRing = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterSupportsRemoteUnlock = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterUnlockOnChildRental = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareProductFilterVendor = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterVendorSerialDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterVendorSerialRegex = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareProductFilterVendorSerialValidationRegex = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterHardwareProductId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterHardwareProductOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterHardwareProductVersionId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterHardwareProductVersionOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterHasLatestFirmwareVersion = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterHasLowBattery = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterHasOfflineUnlockableChild = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIccid = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterImei = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterIsActive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIsAvailable = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIsConnected = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIsInRental = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIsOccupied = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIsOnline = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIsRentable = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterIsUnlocked = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type HardwareFilterLabel = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterLastSeen = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareFilterLat = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterLng = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterLocationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterLocationOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterMac = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterNumber = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterNumberText = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterOpenMaintenanceTickets = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterOverdueMaintenanceTickets = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterRentalCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterRssi = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterState = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareFilterStateName = {
  eq?: HardwareState | null | undefined;
  greaterThan?: HardwareState | null | undefined;
  greaterThanOrEqual?: HardwareState | null | undefined;
  in?: ReadonlyArray<HardwareState | null | undefined> | null | undefined;
  isDistinctFrom?: HardwareState | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: HardwareState | null | undefined;
  lessThan?: HardwareState | null | undefined;
  lessThanOrEqual?: HardwareState | null | undefined;
  notEq?: HardwareState | null | undefined;
};
export type HardwareFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UnlockLogFilterInput = {
  and?: ReadonlyArray<UnlockLogFilterInput> | null | undefined;
  id?: UnlockLogFilterId | null | undefined;
  not?: ReadonlyArray<UnlockLogFilterInput> | null | undefined;
  or?: ReadonlyArray<UnlockLogFilterInput> | null | undefined;
  organizationId?: UnlockLogFilterOrganizationId | null | undefined;
  systemId?: UnlockLogFilterSystemId | null | undefined;
};
export type UnlockLogFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type UnlockLogFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type UnlockLogFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareFilterUnlockSuccessRate = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  input?: HardwareUnlockSuccessRateFieldInput | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareUnlockSuccessRateFieldInput = {
  backwardWindow?: number | null | undefined;
  days?: number | null | undefined;
  endTime?: any | null | undefined;
  startTime?: any | null | undefined;
  unlockWindow?: number | null | undefined;
};
export type HardwareFilterUptime = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  input?: HardwareUptimeFieldInput | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type HardwareUptimeFieldInput = {
  days?: number | null | undefined;
  endTime?: any | null | undefined;
  startTime?: any | null | undefined;
};
export type HardwareFilterVendorId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterVendorQrCode = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type HardwareFilterVendorSerial = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CommunicationLogFilterHardwareId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CommunicationLogFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CommunicationLogFilterIpAddress = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CommunicationLogFilterLogPurpose = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CommunicationLogFilterLogType = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CommunicationLogFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminUserFilterEmail = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type AdminUserFilterFirstName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type AdminUserFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminUserFilterIsMovaticAdmin = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type AdminUserFilterLastName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type AdminSystemPermissionFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemPermissionFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminSystemPermissionFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemPermissionFilterPermissionId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemPermissionFilterRemovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type AdminSystemPermissionFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type AdminSystemPermissionFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterAllowRentalWithoutCard = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterAvailableHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterBannerOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterBilling = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterBillingLive = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterCloseTime = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterCloseTimeInt = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterClosedReason = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterColorPrimary = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterColorSecondary = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterConfig = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterCountryCode = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterCreditCardHold = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterCurrencyCode = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CustomChargeFilterInput = {
  amount?: CustomChargeFilterAmount | null | undefined;
  and?: ReadonlyArray<CustomChargeFilterInput> | null | undefined;
  chargeId?: CustomChargeFilterChargeId | null | undefined;
  created?: CustomChargeFilterCreated | null | undefined;
  description?: CustomChargeFilterDescription | null | undefined;
  id?: CustomChargeFilterId | null | undefined;
  not?: ReadonlyArray<CustomChargeFilterInput> | null | undefined;
  or?: ReadonlyArray<CustomChargeFilterInput> | null | undefined;
  rental?: RentalFilterInput | null | undefined;
  rentalOldId?: CustomChargeFilterRentalOldId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemOldId?: CustomChargeFilterSystemOldId | null | undefined;
  type?: CustomChargeFilterType | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: CustomChargeFilterUserId | null | undefined;
  userOldId?: CustomChargeFilterUserOldId | null | undefined;
};
export type CustomChargeFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CustomChargeFilterChargeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CustomChargeFilterCreated = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type CustomChargeFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type CustomChargeFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CustomChargeFilterRentalOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CustomChargeFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CustomChargeFilterType = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type CustomChargeFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type CustomChargeFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DisputeFilterInput = {
  amount?: DisputeFilterAmount | null | undefined;
  and?: ReadonlyArray<DisputeFilterInput> | null | undefined;
  charge?: ChargeFilterInput | null | undefined;
  chargeId?: DisputeFilterChargeId | null | undefined;
  createdOn?: DisputeFilterCreatedOn | null | undefined;
  evidenceDueBy?: DisputeFilterEvidenceDueBy | null | undefined;
  fee?: DisputeFilterFee | null | undefined;
  id?: DisputeFilterId | null | undefined;
  isOpen?: DisputeFilterIsOpen | null | undefined;
  net?: DisputeFilterNet | null | undefined;
  not?: ReadonlyArray<DisputeFilterInput> | null | undefined;
  or?: ReadonlyArray<DisputeFilterInput> | null | undefined;
  organizationId?: DisputeFilterOrganizationId | null | undefined;
  reason?: DisputeFilterReason | null | undefined;
  status?: DisputeFilterStatus | null | undefined;
  stripeDisputeId?: DisputeFilterStripeDisputeId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: DisputeFilterSystemId | null | undefined;
  user?: UserFilterInput | null | undefined;
  userOldId?: DisputeFilterUserOldId | null | undefined;
};
export type DisputeFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type DisputeFilterChargeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DisputeFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type DisputeFilterEvidenceDueBy = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DisputeFilterFee = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type DisputeFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type DisputeFilterIsOpen = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type DisputeFilterNet = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type DisputeFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type DisputeFilterReason = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DisputeFilterStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DisputeFilterStripeDisputeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type DisputeFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type DisputeFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventBatteryStatusFilterInput = {
  and?: ReadonlyArray<EventBatteryStatusFilterInput> | null | undefined;
  batteryCharging?: EventBatteryStatusFilterBatteryCharging | null | undefined;
  batteryPercent?: EventBatteryStatusFilterBatteryPercent | null | undefined;
  batteryStatus?: EventBatteryStatusFilterBatteryStatus | null | undefined;
  createdOn?: EventBatteryStatusFilterCreatedOn | null | undefined;
  deviceId?: EventBatteryStatusFilterDeviceId | null | undefined;
  eventId?: EventBatteryStatusFilterEventId | null | undefined;
  hardwareReportedOnOldId?: EventBatteryStatusFilterHardwareReportedOnOldId | null | undefined;
  hardwareReporterOldId?: EventBatteryStatusFilterHardwareReporterOldId | null | undefined;
  id?: EventBatteryStatusFilterId | null | undefined;
  not?: ReadonlyArray<EventBatteryStatusFilterInput> | null | undefined;
  or?: ReadonlyArray<EventBatteryStatusFilterInput> | null | undefined;
  organizationId?: EventBatteryStatusFilterOrganizationId | null | undefined;
  recordedAt?: EventBatteryStatusFilterRecordedAt | null | undefined;
  systemId?: EventBatteryStatusFilterSystemId | null | undefined;
  systemOldId?: EventBatteryStatusFilterSystemOldId | null | undefined;
  voltage?: EventBatteryStatusFilterVoltage | null | undefined;
};
export type EventBatteryStatusFilterBatteryCharging = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type EventBatteryStatusFilterBatteryPercent = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventBatteryStatusFilterBatteryStatus = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type EventBatteryStatusFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventBatteryStatusFilterDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type EventBatteryStatusFilterEventId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventBatteryStatusFilterHardwareReportedOnOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventBatteryStatusFilterHardwareReporterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventBatteryStatusFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventBatteryStatusFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventBatteryStatusFilterRecordedAt = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventBatteryStatusFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventBatteryStatusFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventBatteryStatusFilterVoltage = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventErrorFilterInput = {
  and?: ReadonlyArray<EventErrorFilterInput> | null | undefined;
  createdOn?: EventErrorFilterCreatedOn | null | undefined;
  device?: DeviceFilterInput | null | undefined;
  deviceId?: EventErrorFilterDeviceId | null | undefined;
  errorReport?: SupportTicketFilterInput | null | undefined;
  errorReportOldId?: EventErrorFilterErrorReportOldId | null | undefined;
  errorType?: EventErrorFilterErrorType | null | undefined;
  event?: EventFilterInput | null | undefined;
  eventId?: EventErrorFilterEventId | null | undefined;
  hardwareReportedOn?: HardwareFilterInput | null | undefined;
  hardwareReportedOnOldId?: EventErrorFilterHardwareReportedOnOldId | null | undefined;
  hardwareReporter?: HardwareFilterInput | null | undefined;
  hardwareReporterOldId?: EventErrorFilterHardwareReporterOldId | null | undefined;
  id?: EventErrorFilterId | null | undefined;
  inrentalUnlockLogId?: EventErrorFilterInrentalUnlockLogId | null | undefined;
  maintenanceTicket?: MaintenanceTicketFilterInput | null | undefined;
  maintenanceTicketOldId?: EventErrorFilterMaintenanceTicketOldId | null | undefined;
  not?: ReadonlyArray<EventErrorFilterInput> | null | undefined;
  or?: ReadonlyArray<EventErrorFilterInput> | null | undefined;
  organizationId?: EventErrorFilterOrganizationId | null | undefined;
  recordedOn?: EventErrorFilterRecordedOn | null | undefined;
  rental?: RentalFilterInput | null | undefined;
  rentalOldId?: EventErrorFilterRentalOldId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: EventErrorFilterSystemId | null | undefined;
  systemOldId?: EventErrorFilterSystemOldId | null | undefined;
};
export type EventErrorFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventErrorFilterDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type EventErrorFilterErrorReportOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterErrorType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type EventErrorFilterEventId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterHardwareReportedOnOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterHardwareReporterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventErrorFilterInrentalUnlockLogId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterMaintenanceTicketOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterRecordedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventErrorFilterRentalOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventErrorFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventLocationFilterInput = {
  and?: ReadonlyArray<EventLocationFilterInput> | null | undefined;
  createdOn?: EventLocationFilterCreatedOn | null | undefined;
  deviceId?: EventLocationFilterDeviceId | null | undefined;
  eventId?: EventLocationFilterEventId | null | undefined;
  hardwareReportedOnOldId?: EventLocationFilterHardwareReportedOnOldId | null | undefined;
  heading?: EventLocationFilterHeading | null | undefined;
  id?: EventLocationFilterId | null | undefined;
  lat?: EventLocationFilterLat | null | undefined;
  lng?: EventLocationFilterLng | null | undefined;
  not?: ReadonlyArray<EventLocationFilterInput> | null | undefined;
  or?: ReadonlyArray<EventLocationFilterInput> | null | undefined;
  organizationId?: EventLocationFilterOrganizationId | null | undefined;
  recordedOn?: EventLocationFilterRecordedOn | null | undefined;
  speed?: EventLocationFilterSpeed | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: EventLocationFilterSystemId | null | undefined;
};
export type EventLocationFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventLocationFilterDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type EventLocationFilterEventId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventLocationFilterHardwareReportedOnOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventLocationFilterHeading = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventLocationFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventLocationFilterLat = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventLocationFilterLng = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventLocationFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventLocationFilterRecordedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type EventLocationFilterSpeed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type EventLocationFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventStateFilterInput = {
  and?: ReadonlyArray<EventStateFilterInput> | null | undefined;
  id?: EventStateFilterId | null | undefined;
  not?: ReadonlyArray<EventStateFilterInput> | null | undefined;
  or?: ReadonlyArray<EventStateFilterInput> | null | undefined;
  organizationId?: EventStateFilterOrganizationId | null | undefined;
  systemId?: EventStateFilterSystemId | null | undefined;
};
export type EventStateFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventStateFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type EventStateFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type FeeFilterInput = {
  activeOn?: FeeFilterActiveOn | null | undefined;
  amount?: FeeFilterAmount | null | undefined;
  and?: ReadonlyArray<FeeFilterInput> | null | undefined;
  appliedAboveSubTotalThreshold?: FeeFilterAppliedAboveSubTotalThreshold | null | undefined;
  appliedPostTax?: FeeFilterAppliedPostTax | null | undefined;
  appliedToMembers?: FeeFilterAppliedToMembers | null | undefined;
  appliedUnderSubTotalThreshold?: FeeFilterAppliedUnderSubTotalThreshold | null | undefined;
  archivedOn?: FeeFilterArchivedOn | null | undefined;
  createdOn?: FeeFilterCreatedOn | null | undefined;
  description?: FeeFilterDescription | null | undefined;
  id?: FeeFilterId | null | undefined;
  name?: FeeFilterName | null | undefined;
  not?: ReadonlyArray<FeeFilterInput> | null | undefined;
  or?: ReadonlyArray<FeeFilterInput> | null | undefined;
  organizationId?: FeeFilterOrganizationId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: FeeFilterSystemId | null | undefined;
};
export type FeeFilterActiveOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type FeeFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type FeeFilterAppliedAboveSubTotalThreshold = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type FeeFilterAppliedPostTax = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type FeeFilterAppliedToMembers = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type FeeFilterAppliedUnderSubTotalThreshold = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type FeeFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type FeeFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type FeeFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type FeeFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type FeeFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type FeeFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type FeeFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterForceEndPossible = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterGracePeriod = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type GroupSystemFilterInput = {
  and?: ReadonlyArray<GroupSystemFilterInput> | null | undefined;
  id?: GroupSystemFilterId | null | undefined;
  not?: ReadonlyArray<GroupSystemFilterInput> | null | undefined;
  or?: ReadonlyArray<GroupSystemFilterInput> | null | undefined;
  organizationId?: GroupSystemFilterOrganizationId | null | undefined;
};
export type GroupSystemFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type GroupSystemFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductConfigurationFilterInput = {
  and?: ReadonlyArray<HardwareProductConfigurationFilterInput> | null | undefined;
  id?: HardwareProductConfigurationFilterId | null | undefined;
  images?: HardwareProductConfigurationFilterImages | null | undefined;
  not?: ReadonlyArray<HardwareProductConfigurationFilterInput> | null | undefined;
  or?: ReadonlyArray<HardwareProductConfigurationFilterInput> | null | undefined;
  organizationId?: HardwareProductConfigurationFilterOrganizationId | null | undefined;
  rentalProcess?: HardwareProductConfigurationFilterRentalProcess | null | undefined;
  translations?: HardwareProductConfigurationFilterTranslations | null | undefined;
};
export type HardwareProductConfigurationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductConfigurationFilterImages = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareProductConfigurationFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type HardwareProductConfigurationFilterRentalProcess = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type HardwareProductConfigurationFilterTranslations = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterHasRates = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type InvoiceFilterInput = {
  and?: ReadonlyArray<InvoiceFilterInput> | null | undefined;
  canceledOn?: InvoiceFilterCanceledOn | null | undefined;
  createdOn?: InvoiceFilterCreatedOn | null | undefined;
  description?: InvoiceFilterDescription | null | undefined;
  discount?: InvoiceFilterDiscount | null | undefined;
  id?: InvoiceFilterId | null | undefined;
  internalNote?: InvoiceFilterInternalNote | null | undefined;
  not?: ReadonlyArray<InvoiceFilterInput> | null | undefined;
  or?: ReadonlyArray<InvoiceFilterInput> | null | undefined;
  paidOn?: InvoiceFilterPaidOn | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerId?: InvoiceFilterPartnerId | null | undefined;
  paymentDetails?: InvoiceFilterPaymentDetails | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: InvoiceFilterSystemId | null | undefined;
};
export type InvoiceFilterCanceledOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type InvoiceFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type InvoiceFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type InvoiceFilterDiscount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type InvoiceFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type InvoiceFilterInternalNote = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type InvoiceFilterPaidOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type InvoiceFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type InvoiceFilterPaymentDetails = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type InvoiceFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterIsDemoSystem = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterIsPrivateSystem = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterIsVisible = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type IssuingCardFilterInput = {
  and?: ReadonlyArray<IssuingCardFilterInput> | null | undefined;
  cardholderStatus?: IssuingCardFilterCardholderStatus | null | undefined;
  cardholderStripeId?: IssuingCardFilterCardholderStripeId | null | undefined;
  createdOn?: IssuingCardFilterCreatedOn | null | undefined;
  id?: IssuingCardFilterId | null | undefined;
  not?: ReadonlyArray<IssuingCardFilterInput> | null | undefined;
  or?: ReadonlyArray<IssuingCardFilterInput> | null | undefined;
  shippingAddressCity?: IssuingCardFilterShippingAddressCity | null | undefined;
  shippingAddressCountry?: IssuingCardFilterShippingAddressCountry | null | undefined;
  shippingAddressLine1?: IssuingCardFilterShippingAddressLine1 | null | undefined;
  shippingAddressLine2?: IssuingCardFilterShippingAddressLine2 | null | undefined;
  shippingAddressState?: IssuingCardFilterShippingAddressState | null | undefined;
  shippingAddressZip?: IssuingCardFilterShippingAddressZip | null | undefined;
  spendingLimitAmount?: IssuingCardFilterSpendingLimitAmount | null | undefined;
  spendingLimitInterval?: IssuingCardFilterSpendingLimitInterval | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: IssuingCardFilterSystemId | null | undefined;
  type?: IssuingCardFilterType | null | undefined;
  updatedOn?: IssuingCardFilterUpdatedOn | null | undefined;
};
export type IssuingCardFilterCardholderStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterCardholderStripeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type IssuingCardFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type IssuingCardFilterShippingAddressCity = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterShippingAddressCountry = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterShippingAddressLine1 = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterShippingAddressLine2 = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterShippingAddressState = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterShippingAddressZip = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterSpendingLimitAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type IssuingCardFilterSpendingLimitInterval = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type IssuingCardFilterType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type IssuingCardFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterLat = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterLng = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterLogoOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterInput = {
  and?: ReadonlyArray<MaintenanceRecurringRuleFilterInput> | null | undefined;
  archivedOn?: MaintenanceRecurringRuleFilterArchivedOn | null | undefined;
  completionWindow?: MaintenanceRecurringRuleFilterCompletionWindow | null | undefined;
  createdOn?: MaintenanceRecurringRuleFilterCreatedOn | null | undefined;
  id?: MaintenanceRecurringRuleFilterId | null | undefined;
  maintenanceTask?: MaintenanceTaskFilterInput | null | undefined;
  maintenanceTaskOldId?: MaintenanceRecurringRuleFilterMaintenanceTaskOldId | null | undefined;
  not?: ReadonlyArray<MaintenanceRecurringRuleFilterInput> | null | undefined;
  oldId?: MaintenanceRecurringRuleFilterOldId | null | undefined;
  or?: ReadonlyArray<MaintenanceRecurringRuleFilterInput> | null | undefined;
  organizationId?: MaintenanceRecurringRuleFilterOrganizationId | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerMaintenanceProgram?: MaintenanceRecurringRuleFilterPartnerMaintenanceProgram | null | undefined;
  partnerOldId?: MaintenanceRecurringRuleFilterPartnerOldId | null | undefined;
  priority?: MaintenanceRecurringRuleFilterPriority | null | undefined;
  recurringIncrement?: MaintenanceRecurringRuleFilterRecurringIncrement | null | undefined;
  recurringType?: MaintenanceRecurringRuleFilterRecurringType | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: MaintenanceRecurringRuleFilterSystemId | null | undefined;
  systemOldId?: MaintenanceRecurringRuleFilterSystemOldId | null | undefined;
};
export type MaintenanceRecurringRuleFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceRecurringRuleFilterCompletionWindow = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MaintenanceRecurringRuleFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceRecurringRuleFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterMaintenanceTaskOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterPartnerMaintenanceProgram = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterPartnerOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterPriority = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MaintenanceRecurringRuleFilterRecurringIncrement = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type MaintenanceRecurringRuleFilterRecurringType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceRecurringRuleFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketTagFilterInput = {
  and?: ReadonlyArray<MaintenanceTicketTagFilterInput> | null | undefined;
  archivedOn?: MaintenanceTicketTagFilterArchivedOn | null | undefined;
  createdOn?: MaintenanceTicketTagFilterCreatedOn | null | undefined;
  id?: MaintenanceTicketTagFilterId | null | undefined;
  name?: MaintenanceTicketTagFilterName | null | undefined;
  not?: ReadonlyArray<MaintenanceTicketTagFilterInput> | null | undefined;
  or?: ReadonlyArray<MaintenanceTicketTagFilterInput> | null | undefined;
  organizationId?: MaintenanceTicketTagFilterOrganizationId | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerId?: MaintenanceTicketTagFilterPartnerId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: MaintenanceTicketTagFilterSystemId | null | undefined;
};
export type MaintenanceTicketTagFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketTagFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type MaintenanceTicketTagFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketTagFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type MaintenanceTicketTagFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketTagFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type MaintenanceTicketTagFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ManualChargeFilterInput = {
  admin?: AdminUserFilterInput | null | undefined;
  adminId?: ManualChargeFilterAdminId | null | undefined;
  amount?: ManualChargeFilterAmount | null | undefined;
  and?: ReadonlyArray<ManualChargeFilterInput> | null | undefined;
  approvedOn?: ManualChargeFilterApprovedOn | null | undefined;
  canceledOn?: ManualChargeFilterCanceledOn | null | undefined;
  charge?: ChargeFilterInput | null | undefined;
  chargeId?: ManualChargeFilterChargeId | null | undefined;
  createdOn?: ManualChargeFilterCreatedOn | null | undefined;
  currency?: ManualChargeFilterCurrency | null | undefined;
  description?: ManualChargeFilterDescription | null | undefined;
  failedOn?: ManualChargeFilterFailedOn | null | undefined;
  id?: ManualChargeFilterId | null | undefined;
  metadata?: ManualChargeFilterMetadata | null | undefined;
  not?: ReadonlyArray<ManualChargeFilterInput> | null | undefined;
  or?: ReadonlyArray<ManualChargeFilterInput> | null | undefined;
  organizationId?: ManualChargeFilterOrganizationId | null | undefined;
  recipient?: ManualChargeFilterRecipient | null | undefined;
  rejectedOn?: ManualChargeFilterRejectedOn | null | undefined;
  retriedOn?: ManualChargeFilterRetriedOn | null | undefined;
  reviewedBy?: ManualChargeFilterReviewedBy | null | undefined;
  reviewer?: AdminUserFilterInput | null | undefined;
  status?: ManualChargeFilterStatus | null | undefined;
  succeededOn?: ManualChargeFilterSucceededOn | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: ManualChargeFilterSystemId | null | undefined;
  updatedOn?: ManualChargeFilterUpdatedOn | null | undefined;
  user?: UserFilterInput | null | undefined;
  userId?: ManualChargeFilterUserId | null | undefined;
};
export type ManualChargeFilterAdminId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ManualChargeFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type ManualChargeFilterApprovedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterCanceledOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterChargeId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ManualChargeFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterCurrency = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ManualChargeFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ManualChargeFilterFailedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ManualChargeFilterMetadata = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ManualChargeFilterRecipient = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ManualChargeFilterRejectedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterRetriedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterReviewedBy = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ManualChargeFilterStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ManualChargeFilterSucceededOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ManualChargeFilterUpdatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ManualChargeFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterMaxChargeThreshold = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterMaxOpenRentals = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterMaxSpeed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterMinimumWalletDeposit = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterMobilityType = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterNewHardware = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type NotificationFilterInput = {
  and?: ReadonlyArray<NotificationFilterInput> | null | undefined;
  id?: NotificationFilterId | null | undefined;
  not?: ReadonlyArray<NotificationFilterInput> | null | undefined;
  or?: ReadonlyArray<NotificationFilterInput> | null | undefined;
};
export type NotificationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterOpenDisputesCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterOpenTime = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterOpenTimeInt = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterOperatingHours = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterOutsideSystemMaxSpeed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterOverdueMaintenanceTicketCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterOwnerEmail = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterParkingCreditOutsideDesignated = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterParkingCreditOutsideSystemServiceZone = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterParkingCreditParkingZone = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterParkingCreditPreferredParkingZone = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterParkingCreditRackStation = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterParkingCreditRestrictedZone = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterPendingChargesCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterProviderId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterProviderName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type QrCodeReservationFilterInput = {
  and?: ReadonlyArray<QrCodeReservationFilterInput> | null | undefined;
  archivedOn?: QrCodeReservationFilterArchivedOn | null | undefined;
  createdOn?: QrCodeReservationFilterCreatedOn | null | undefined;
  id?: QrCodeReservationFilterId | null | undefined;
  not?: ReadonlyArray<QrCodeReservationFilterInput> | null | undefined;
  or?: ReadonlyArray<QrCodeReservationFilterInput> | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerId?: QrCodeReservationFilterPartnerId | null | undefined;
  rangeEnd?: QrCodeReservationFilterRangeEnd | null | undefined;
  rangeStart?: QrCodeReservationFilterRangeStart | null | undefined;
  replacedBy?: QrCodeReservationFilterReplacedBy | null | undefined;
  replacedByAdmin?: QrCodeReservationFilterReplacedByAdmin | null | undefined;
  replacedByAdminUser?: AdminUserFilterInput | null | undefined;
  replacement?: QrCodeReservationFilterInput | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: QrCodeReservationFilterSystemId | null | undefined;
};
export type QrCodeReservationFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type QrCodeReservationFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type QrCodeReservationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeReservationFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeReservationFilterRangeEnd = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type QrCodeReservationFilterRangeStart = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type QrCodeReservationFilterReplacedBy = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeReservationFilterReplacedByAdmin = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type QrCodeReservationFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterRentableHardwareCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterRentableHardwareTypeId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterRentalLengthWarning = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalRouteFilterInput = {
  and?: ReadonlyArray<RentalRouteFilterInput> | null | undefined;
  deviceId?: RentalRouteFilterDeviceId | null | undefined;
  hardware?: HardwareFilterInput | null | undefined;
  hardwareReportedOnId?: RentalRouteFilterHardwareReportedOnId | null | undefined;
  heading?: RentalRouteFilterHeading | null | undefined;
  id?: RentalRouteFilterId | null | undefined;
  latitude?: RentalRouteFilterLatitude | null | undefined;
  longitude?: RentalRouteFilterLongitude | null | undefined;
  not?: ReadonlyArray<RentalRouteFilterInput> | null | undefined;
  or?: ReadonlyArray<RentalRouteFilterInput> | null | undefined;
  recordedOn?: RentalRouteFilterRecordedOn | null | undefined;
  sourceId?: RentalRouteFilterSourceId | null | undefined;
  sourceType?: RentalRouteFilterSourceType | null | undefined;
  speed?: RentalRouteFilterSpeed | null | undefined;
  system?: SystemFilterInput | null | undefined;
};
export type RentalRouteFilterDeviceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalRouteFilterHardwareReportedOnId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalRouteFilterHeading = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalRouteFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalRouteFilterLatitude = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalRouteFilterLongitude = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalRouteFilterRecordedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalRouteFilterSourceId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalRouteFilterSourceType = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type RentalRouteFilterSpeed = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalTutorialFilterInput = {
  and?: ReadonlyArray<RentalTutorialFilterInput> | null | undefined;
  createdOn?: RentalTutorialFilterCreatedOn | null | undefined;
  hardwareProduct?: HardwareProductFilterInput | null | undefined;
  hardwareProductOldId?: RentalTutorialFilterHardwareProductOldId | null | undefined;
  id?: RentalTutorialFilterId | null | undefined;
  not?: ReadonlyArray<RentalTutorialFilterInput> | null | undefined;
  or?: ReadonlyArray<RentalTutorialFilterInput> | null | undefined;
  organizationId?: RentalTutorialFilterOrganizationId | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerOldId?: RentalTutorialFilterPartnerOldId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: RentalTutorialFilterSystemId | null | undefined;
  systemOldId?: RentalTutorialFilterSystemOldId | null | undefined;
};
export type RentalTutorialFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type RentalTutorialFilterHardwareProductOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalTutorialFilterId = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RentalTutorialFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalTutorialFilterPartnerOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalTutorialFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type RentalTutorialFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterRentalsCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterRequireCreditCard = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterRoundTrip = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemFilterStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterStripeAccount = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterSupportPhoneNumber = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketTagFilterInput = {
  and?: ReadonlyArray<SupportTicketTagFilterInput> | null | undefined;
  archivedOn?: SupportTicketTagFilterArchivedOn | null | undefined;
  createdOn?: SupportTicketTagFilterCreatedOn | null | undefined;
  id?: SupportTicketTagFilterId | null | undefined;
  name?: SupportTicketTagFilterName | null | undefined;
  not?: ReadonlyArray<SupportTicketTagFilterInput> | null | undefined;
  or?: ReadonlyArray<SupportTicketTagFilterInput> | null | undefined;
  organizationId?: SupportTicketTagFilterOrganizationId | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerId?: SupportTicketTagFilterPartnerId | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: SupportTicketTagFilterSystemId | null | undefined;
};
export type SupportTicketTagFilterArchivedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SupportTicketTagFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SupportTicketTagFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketTagFilterName = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SupportTicketTagFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketTagFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SupportTicketTagFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterSupportTicketsCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemFilterSupportsInRentalUnlock = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterInput = {
  additionalRentalTos?: SystemConfigurationFilterAdditionalRentalTos | null | undefined;
  allowEndingRentalsOutsideStation?: SystemConfigurationFilterAllowEndingRentalsOutsideStation | null | undefined;
  alwaysShowRentalTutorial?: SystemConfigurationFilterAlwaysShowRentalTutorial | null | undefined;
  alwaysShowWalkthroughRentalDetails?: SystemConfigurationFilterAlwaysShowWalkthroughRentalDetails | null | undefined;
  and?: ReadonlyArray<SystemConfigurationFilterInput> | null | undefined;
  createdOn?: SystemConfigurationFilterCreatedOn | null | undefined;
  customStatementBillingDescriptor?: SystemConfigurationFilterCustomStatementBillingDescriptor | null | undefined;
  data?: SystemConfigurationFilterData | null | undefined;
  disableEndRentalNearestStation?: SystemConfigurationFilterDisableEndRentalNearestStation | null | undefined;
  disableUserEndRentals?: SystemConfigurationFilterDisableUserEndRentals | null | undefined;
  disableUserStartRentals?: SystemConfigurationFilterDisableUserStartRentals | null | undefined;
  enableAdminStartRentals?: SystemConfigurationFilterEnableAdminStartRentals | null | undefined;
  enablePhotoEndRental?: SystemConfigurationFilterEnablePhotoEndRental | null | undefined;
  endRentalImage?: ImageFilterInput | null | undefined;
  endRentalWebsite?: SystemConfigurationFilterEndRentalWebsite | null | undefined;
  hideReturnLocations?: SystemConfigurationFilterHideReturnLocations | null | undefined;
  id?: SystemConfigurationFilterId | null | undefined;
  images?: SystemConfigurationFilterImages | null | undefined;
  manualChargeReviewThreshold?: SystemConfigurationFilterManualChargeReviewThreshold | null | undefined;
  maxMembershipRenewalAttempts?: SystemConfigurationFilterMaxMembershipRenewalAttempts | null | undefined;
  minMinutesToRent?: SystemConfigurationFilterMinMinutesToRent | null | undefined;
  movaticDefault?: SystemConfigurationFilterMovaticDefault | null | undefined;
  not?: ReadonlyArray<SystemConfigurationFilterInput> | null | undefined;
  or?: ReadonlyArray<SystemConfigurationFilterInput> | null | undefined;
  partner?: PartnerFilterInput | null | undefined;
  partnerId?: SystemConfigurationFilterPartnerId | null | undefined;
  preventEndingRentalsOutsideServiceZone?: SystemConfigurationFilterPreventEndingRentalsOutsideServiceZone | null | undefined;
  replacedBy?: SystemConfigurationFilterReplacedBy | null | undefined;
  replacedByAdmin?: SystemConfigurationFilterReplacedByAdmin | null | undefined;
  replacedByAdminUser?: AdminUserFilterInput | null | undefined;
  replacedOn?: SystemConfigurationFilterReplacedOn | null | undefined;
  replacement?: SystemConfigurationFilterInput | null | undefined;
  requireTermsAdditionalRentals?: SystemConfigurationFilterRequireTermsAdditionalRentals | null | undefined;
  requireTosOnEveryRental?: SystemConfigurationFilterRequireTosOnEveryRental | null | undefined;
  startRentalImage?: ImageFilterInput | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: SystemConfigurationFilterSystemId | null | undefined;
  translations?: SystemConfigurationFilterTranslations | null | undefined;
  unitSelectionScreen?: SystemConfigurationFilterUnitSelectionScreen | null | undefined;
  useDynamicPricing?: SystemConfigurationFilterUseDynamicPricing | null | undefined;
  useGlobalWallet?: SystemConfigurationFilterUseGlobalWallet | null | undefined;
  useRateGracePeriod?: SystemConfigurationFilterUseRateGracePeriod | null | undefined;
  useRentalMinutes?: SystemConfigurationFilterUseRentalMinutes | null | undefined;
  useUserDeviceGps?: SystemConfigurationFilterUseUserDeviceGps | null | undefined;
  userEndRentalImage?: SystemConfigurationFilterUserEndRentalImage | null | undefined;
  userEndRentalMessage?: SystemConfigurationFilterUserEndRentalMessage | null | undefined;
  userStartRentalImage?: SystemConfigurationFilterUserStartRentalImage | null | undefined;
  userStartRentalMessage?: SystemConfigurationFilterUserStartRentalMessage | null | undefined;
};
export type SystemConfigurationFilterAdditionalRentalTos = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemConfigurationFilterAllowEndingRentalsOutsideStation = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterAlwaysShowRentalTutorial = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterAlwaysShowWalkthroughRentalDetails = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterCreatedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemConfigurationFilterCustomStatementBillingDescriptor = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemConfigurationFilterData = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemConfigurationFilterDisableEndRentalNearestStation = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterDisableUserEndRentals = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterDisableUserStartRentals = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterEnableAdminStartRentals = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterEnablePhotoEndRental = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterEndRentalWebsite = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemConfigurationFilterHideReturnLocations = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemConfigurationFilterImages = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemConfigurationFilterManualChargeReviewThreshold = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemConfigurationFilterMaxMembershipRenewalAttempts = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemConfigurationFilterMinMinutesToRent = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type SystemConfigurationFilterMovaticDefault = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterPartnerId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemConfigurationFilterPreventEndingRentalsOutsideServiceZone = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterReplacedBy = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemConfigurationFilterReplacedByAdmin = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemConfigurationFilterReplacedOn = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemConfigurationFilterRequireTermsAdditionalRentals = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterRequireTosOnEveryRental = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemConfigurationFilterTranslations = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemConfigurationFilterUnitSelectionScreen = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemConfigurationFilterUseDynamicPricing = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterUseGlobalWallet = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterUseRateGracePeriod = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterUseRentalMinutes = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterUseUserDeviceGps = {
  eq?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqual?: boolean | null | undefined;
  in?: ReadonlyArray<boolean | null | undefined> | null | undefined;
  isDistinctFrom?: boolean | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqual?: boolean | null | undefined;
  notEq?: boolean | null | undefined;
};
export type SystemConfigurationFilterUserEndRentalImage = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemConfigurationFilterUserEndRentalMessage = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemConfigurationFilterUserStartRentalImage = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemConfigurationFilterUserStartRentalMessage = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterTaxRate = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterTestStripeAccount = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterTimezone = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type SystemFilterTimezoneOffset = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type SystemFilterTos = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type TransferFilterInput = {
  amount?: TransferFilterAmount | null | undefined;
  and?: ReadonlyArray<TransferFilterInput> | null | undefined;
  created?: TransferFilterCreated | null | undefined;
  description?: TransferFilterDescription | null | undefined;
  id?: TransferFilterId | null | undefined;
  not?: ReadonlyArray<TransferFilterInput> | null | undefined;
  or?: ReadonlyArray<TransferFilterInput> | null | undefined;
  organizationId?: TransferFilterOrganizationId | null | undefined;
  status?: TransferFilterStatus | null | undefined;
  system?: SystemFilterInput | null | undefined;
  systemId?: TransferFilterSystemId | null | undefined;
  systemOldId?: TransferFilterSystemOldId | null | undefined;
};
export type TransferFilterAmount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type TransferFilterCreated = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type TransferFilterDescription = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type TransferFilterId = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type TransferFilterOrganizationId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type TransferFilterStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type TransferFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type TransferFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type SystemFilterUsersCount = {
  eq?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqual?: number | null | undefined;
  in?: ReadonlyArray<number | null | undefined> | null | undefined;
  isDistinctFrom?: number | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: number | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqual?: number | null | undefined;
  notEq?: number | null | undefined;
};
export type RefundFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeFilterStatus = {
  contains?: string | null | undefined;
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  ilike?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  like?: string | null | undefined;
  notEq?: string | null | undefined;
  stringEndsWith?: string | null | undefined;
  stringStartsWith?: string | null | undefined;
};
export type ChargeFilterSystemId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeFilterSystemOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeFilterTaxAmount = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ChargeFilterTaxRate = {
  eq?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqual?: any | null | undefined;
  in?: ReadonlyArray<any | null | undefined> | null | undefined;
  isDistinctFrom?: any | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: any | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqual?: any | null | undefined;
  notEq?: any | null | undefined;
};
export type ChargeFilterUserId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeFilterUserOldId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeFilterWalletId = {
  eq?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqual?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDistinctFrom?: string | null | undefined;
  isNil?: boolean | null | undefined;
  isNotDistinctFrom?: string | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqual?: string | null | undefined;
  notEq?: string | null | undefined;
};
export type ChargeSortInput = {
  field: ChargeSortField;
  order?: SortOrder | null | undefined;
};
export type useChargesRelayQuery$variables = {
  after?: string | null | undefined;
  filter?: ChargeFilterInput | null | undefined;
  first?: number | null | undefined;
  sort?: ReadonlyArray<ChargeSortInput> | null | undefined;
};
export type useChargesRelayQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useChargesRelayPaginationFragment">;
};
export type useChargesRelayQuery = {
  response: useChargesRelayQuery$data;
  variables: useChargesRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChargesRelayQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "useChargesRelayPaginationFragment"
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useChargesRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ChargeConnection",
        "kind": "LinkedField",
        "name": "listCharges",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChargeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Charge",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountRefunded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "chargeTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "holdAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentIntentId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refundStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refunded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "systemId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "systemOldId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taxAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taxRate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userOldId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "walletId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organizationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partnerCharge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "System",
                    "kind": "LinkedField",
                    "name": "system",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "oldId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Rental",
                    "kind": "LinkedField",
                    "name": "rental",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": [
          "filter",
          "sort"
        ],
        "handle": "connection",
        "key": "useChargesRelayPaginationFragment_listCharges",
        "kind": "LinkedHandle",
        "name": "listCharges"
      }
    ]
  },
  "params": {
    "cacheID": "fa596709bb3bf6d9918f0a12710e291c",
    "id": null,
    "metadata": {},
    "name": "useChargesRelayQuery",
    "operationKind": "query",
    "text": "query useChargesRelayQuery(\n  $first: Int\n  $after: String\n  $filter: ChargeFilterInput\n  $sort: [ChargeSortInput!]\n) {\n  ...useChargesRelayPaginationFragment_3JsJJ3\n}\n\nfragment useChargesRelayPaginationFragment_3JsJJ3 on RootQueryType {\n  listCharges(first: $first, after: $after, filter: $filter, sort: $sort) {\n    count\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        amount\n        amountRefunded\n        chargeTotal\n        created\n        description\n        holdAmount\n        paymentIntentId\n        refundStatus\n        refunded\n        status\n        systemId\n        systemOldId\n        taxAmount\n        taxRate\n        userId\n        userOldId\n        walletId\n        organizationId\n        partnerCharge\n        user {\n          id\n          firstName\n          lastName\n          email\n        }\n        system {\n          id\n          oldId\n          name\n        }\n        rental {\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5edf154ff44e315f11c6f2eb53baa689";

export default node;
